// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.history-offcanvas-wrapper.offcanvas.offcanvas-end.show {
  width: 50%;
  box-shadow: -5px 0px 14px #0000000d;
  border-radius: 34px 0px 0px 34px;
  padding: 20px 0px 40px 40px;
  z-index: 99999;
  border: none;
}

.extras-offcanvas-wrapper.offcanvas.offcanvas-end.show {
  width: 620px;
  box-shadow: -5px 0px 14px #0000000d;
  border-radius: 0px 0px 0px 0px;
  border-left: 5px solid #00a19b;
  padding: 30px 0px 0px 40px;
  z-index: 99999;
  border: none;
}

.postpaid-offcanvas-wrapper.offcanvas.offcanvas-end.show {
  padding: 30px 40px 0px 40px;
}

.postpaid-offcanvas-wrapper .extra-drawer-main-header {
  padding-right: 0px;
}

.extras-offcanvas-wrapper .offcanvas-body {
  padding-bottom: 0px;
  padding-right: 0px;
}

.addition-drawer-main-wrap {
  height: calc(100vh - 200px);
  padding-right: 40px;
  overflow: auto;
}

.extras-offcanvas-wrapper.active.offcanvas.offcanvas-end.show {
  width: 775px;
}

.coupon-offcanvas-wrapper.offcanvas.offcanvas-end.show {
  width: 530px;
  box-shadow: -5px 0px 14px #0000000d;
  border-radius: 0px 0px 0px 0px;
  border-left: 5px solid #00a19b;
  padding: 20px 26px 40px 60px;
  z-index: 99999;
  border: none;
}

.notification-offcanvas-wrapper.offcanvas.offcanvas-end.show {
  width: 725px;
  box-shadow: -5px 0px 14px #0000000d;
  border-radius: 34px 0px 0px 34px;
  padding: 30px 0px 40px 72px;
  z-index: 99999;
  border: none;
}

.notification-offcanvas-wrapper .offcanvas-body {
  padding: 0px;
}

.notification-drawer-main-wrap {
  padding-right: 30px;
}

.chat-drawer-main-wrap {
  padding-right: 0px;
}

.chat-drawer-main-wrap .notification-drawer-header {
  padding-right: 46px;
}

.chat-drawer-main-wrap .chat-send-message-wrapper {
  padding-right: 46px;
}

.cart-offcanvas-wrapper.offcanvas.offcanvas-end.show {
  width: 775px;
  box-shadow: -5px 0px 14px #0000000d;
  border-radius: 34px 0px 0px 34px;
  padding: 20px 0px 120px 62px;
  z-index: 99999;
  border: none;
}

.chat-offcanvas-wrapper.offcanvas.offcanvas-end.show {
  width: 724px;
  box-shadow: -5px 0px 14px #0000000d;
  border-radius: 34px 0px 0px 34px;
  padding: 20px 0px 0px 56px;
  z-index: 99999;
}

.chat-offcanvas-wrapper .offcanvas-body {
  padding: 0px;
}

.drawer-main-header-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 35px;
  padding-left: 20px;
  padding-right: 20px;
}

.drawer-main-header-wrap h4 {
  font-size: 24px;
  color: #1a1919;
  font-weight: 600;
  margin: 0px;
}

.drawer-main-header-wrap img {
  cursor: pointer;
}

.drawer-close-icon img {
  font-size: 38px;
  cursor: pointer;
}

.history-list-drawer-table thead {
  background-color: #00a19b08;
}

.history-list-drawer-table .table.table-hover thead th {
  padding: 10px;
  background-color: #00a19b08;
}

.history-list-drawer-table .table-hover > tbody > tr:hover > * {
  --bs-table-color-state: unset !important;
  --bs-table-bg-state: unset !important;
}

.history-list-drawer-table tbody,
td,
tfoot,
th,
thead,
tr {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border: none;
}

.history-list-drawer-table thead th:first-child {
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}

.history-list-drawer-table thead th:last-child {
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
}

.history-list-drawer-table .table.table-hover thead th {
  color: #383838;
  font-size: 20px;
}

.history-list-drawer-table .table tbody tr td {
  font-size: 18px;
  cursor: pointer;
}

.history-list-drawer-table .table.table-hover thead th {
  color: #383838;
  font-size: 18px;
  padding-left: 22px;
}

.history-list-drawer-table .table tbody tr:first-child td {
  padding-top: 20px;
}

.history-list-drawer-table .table tbody tr td {
  color: #717171;
  font-size: 18px;
  white-space: nowrap;
  padding-left: 20px;
  vertical-align: middle;
}

/* .history-list-drawer-table .table-responsive {
    -webkit-overflow-scrolling: touch;
    height: 85vh;
    overflow-x: auto;
    overflow-y: auto;
  } */

.history-item-images-wrapper {
  display: flex;
  align-items: center;
  gap: 22px;
}

.history-item-images-holder {
  display: flex;
  width: 55px;
}

.history-item-image-box {
  width: 34px;
  height: 34px;
  background: #f3f3f3;
  border-radius: 50%;
  margin-left: -14px;
  overflow: hidden;
  object-fit: cover;
  padding: 4px;
}

.history-item-images-holder img {
  width: 100%;
}

.history-item-images-wrapper img.main-image {
  width: 46px;
}

.items-hold-wrap {
  display: flex;
  align-items: center;
  gap: 0px;
}

.items-hold-wrap p {
  width: 200px;
  font-size: 18px;
  color: #717171;
  font-weight: 400;
  margin: 0px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.items-hold-wrap span {
  font-size: 18px;
  color: #00a19b;
  font-weight: 400;
  margin: 0px;
}

.notification-drawer-header h3 {
  font-size: 24px;
  color: #1a1919;
  font-weight: 600;
  margin: 0px;
}

.notification-drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  background: #fff;
  padding-top: 20px;
}

.notification-drawer-header img {
  width: 38px;
  cursor: pointer;
}

.notification-items-wrap {
  display: flex;
  align-items: center;
  gap: 0px;
  margin-left: 14px;
  width: 60px;
}

.notification-item-image {
  width: 34px;
  background: #f3f3f3;
  border-radius: 50%;
  margin-left: -14px;
  padding: 2px;
}

.notification-item-image img {
  width: 100%;
}

.notification-title-wrap {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
}

.notification-title-wrap h4 {
  font-size: 18px;
  color: #1a1919;
  font-weight: bold;
  margin: 0px;
}

.notification-title-wrap img {
  width: 24px;
}

.notification-left-wrap {
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.notification-booking-id-wrap p {
  font-size: 16px;
  color: #1a1919;
  font-weight: 500;
  margin: 0px;
}

.notification-booking-id-wrap p span{
  /* color: #0000EE; */
  color: #00a19b;
  cursor: pointer;
}

.notification-booking-id-wrap p span:hover{
  color: #008081;
}

.notification-item-date-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 2px;
}

.notification-item-date-wrap.border-line p:last-child {
  border-left: 1px solid #ccc;
  padding-left: 10px;
}

.notification-item-desc p {
  width: 350px;
  font-size: 14px;
  color: #6d6d6d;
  font-weight: 400;
  margin: 0px;
}

.notification-item-date-wrap p {
  font-size: 14px;
  color: #6d6d6d;
  font-weight: 400;
  margin: 0px;
}

/* .notification-item-date-wrap p:last-child  {
  border-left: 1px solid #ccc;
  padding-left: 10px;
} */

.notification-item-date-wrap:has(> p:nth-child(2)):not(:has(> p:nth-child(3))) p:last-child {
  border-left: 1px solid #ccc;
  padding-left: 10px;
}

.notification-order-repeat {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 40px;
}

.notification-item-price h4 {
  font-size: 16px;
  color: #00a19b;
  font-weight: 600;
  margin: 0px;
}

.notification-date-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 40px;
}

.notification-line-wrap {
  width: 100%;
  height: 1px;
  background: #f3f3f3;
}

.notification-date-wrap p {
  font-size: 14px;
  color: #626262;
  font-weight: 400;
  margin: 0px;
}

/************** Chat Masseges Drawer ****/
.replay-chat-box-wrapper {
  position: relative;
  /* margin-top: 20px; */
  width: 100%;
  height: calc(100vh - 140px);
}

/******** Chat Bot Msg *****/
.msger-chat {
  flex: 1 1;
  overflow-y: auto;
  padding: 0px;
  height: calc(100vh - 230px);
  margin-top: 10px;
  padding-right: 46px;
}

.msger-chat::-webkit-scrollbar {
  width: 5px;
  border-radius: 10px;
}

.msger-chat::-webkit-scrollbar-track {
  background: #ddd;
}

.msger-chat::-webkit-scrollbar-thumb {
  background: #00a19b;
}

.msg {
  display: flex;
  align-items: flex-end;
}

.msg:last-of-type {
  margin: 0;
}

.msg-bubble {
  max-width: 450px;
  padding: 15px;
  border-radius: 25px;
  background: #bae9e9;
}

.msg-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.msg-info-name {
  font-size: 14px;
  color: #313131;
  font-weight: 500;
  margin-left: 20px;
}

.msg-info-time {
  font-size: 0.85em;
}

.right-msg {
  flex-direction: row-reverse;
}

.right-msg .msg-bubble {
  background: #00a19b;
  color: #fff;
  border-radius: 25px;
}

.replay-chat-box-wrap .msg.left-msg .msg-text {
  font-size: 16px;
  color: #1a1919;
  font-weight: 600;
  margin: 0px;
}

.replay-chat-box-wrap .msg .msg-text {
  font-size: 16px;
  color: #ffffff;
  font-weight: 600;
  margin: 0px;
}

.chat-right-message-wrap .msg-info-time p {
  font-size: 14px;
  color: #b5b5b5;
  font-weight: 400;
  margin: 0px;
  text-align: right;
  padding-right: 10px;
}

.chat-left-message-wrap .msg-info-time p {
  font-size: 14px;
  color: #b5b5b5;
  font-weight: 400;
  margin: 0px;
  padding-right: 10px;
}

.chat-right-message-wrap {
  margin-bottom: 16px;
}

.right-info-time {
  text-align: right;
}

.left-info-time {
  text-align: left;
}

.right-info-time p,
.left-info-time p {
  font-size: 14px;
  color: #b5b5b5;
  font-weight: 400;
  padding-top: 4px;
  margin-left: 20px;
  margin-right: 20px;
}

.chat-send-message-wrapper {
  position: absolute;
  width: 100%;
  bottom: 0px;
}

.chat-send-message-wrap {
  position: relative;
}

.chat-send-message-wrap input {
  width: 100%;
  height: 82px;
  border: 1px solid #dfdfdf;
  border-radius: 42px;
  outline: none;
  padding: 30px;
}

.chat-send-button img {
  width: 65px;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.cleaner-partner.right {
  display: none;
}

.cleaner-partner.left {
  font-size: 18px;
  color: #1a1919;
  font-weight: 400;
  margin: 0px;
  margin-bottom: 4px;
}

.empty-conversation-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: calc(100vh - 260px);
}

.empty-conversation-wrap h3 {
  font-size: 25px;
  color: #1a1919;
  font-weight: bold;
  margin: 0px;
}

.empty-conversation-wrap p {
  font-size: 22px;
  color: #1a1919;
  font-weight: 400;
  text-align: center;
  width: 60%;
  padding-top: 10px;
}

.empty-conversation-wrap img {
  width: 150px;
}

/******* Extra Drawer Css ****/
.extra-drawer-main-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
  padding-right: 40px;
}

.extra-back-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}

.extra-drawer-main-header h4 {
  font-size: 16px;
  margin: 0px;
  font-weight: 600;
}

.extra-drawer-size-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}

.extra-drawer-size {
  width: 140px;
  height: 40px;
  border: 1px solid #f3f3f3;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.extra-drawer-size p {
  font-size: 14px;
  font-weight: 400;
  color: #a2a2a2;
  margin: 0px;
}

.extra-drawer-price {
  margin-top: 8px;
}

.extra-drawer-price p {
  font-size: 12px;
  text-align: center;
  margin: 0px;
  color: #626262;
  font-weight: 400;
}

.extra-drawer-size-repeat.active .extra-drawer-size {
  border: 1px solid #00a19b;
}

.extra-drawer-size-repeat.active .extra-drawer-size p {
  font-weight: 500;
  color: #00a19b;
}

.extra-drawer-size-repeat.active .extra-drawer-price p {
  color: #00a19b;
  font-weight: 500;
}

.extra-drawer-size-wrapper h4 {
  font-size: 14px;
  font-weight: 600;
  margin: 0px;
  color: #1a1919;
}

.extra-category-dropdown-wrap {
  /* margin-top: 50px; */
  margin-top: 38px;
}

.extra-drawer-main-wrapper {
  position: relative;
  min-height: calc(100vh - 110px);
}

/* .extra-addto-cart-btn{
  width: 100%;
  position: absolute;
  bottom: 10px;
} */

.extra-addto-cart-btn {
  width: 100%;
  position: sticky;
  bottom: 0px;
  background: #fff;
  z-index: 999999;
  padding-right: 40px;
  padding-bottom: 20px;
  padding-top: 20px;
}

.extra-close-drwaer-btn img {
  width: 30px;
  cursor: pointer;
}

.extra-close-drwaer-btn:hover img {
  transform: scale(0.9);
}

.addition-drawer-item-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}

.addition-drawer-item-wrap img {
  width: 84px;
  height: 90px;
}

.addition-drawer-item-wrap p {
  font-size: 19px;
  font-weight: 500;
  margin: 0px;
  color: #1a1919;
}

.additional-drawer-sqfeet-wrap p {
  font-size: 14px;
  color: #1a1919;
  font-weight: 600;
  margin: 0px;
  margin-bottom: 10px;
}

/***** Coupon Drawer css *******/

.apply-coupan-input {
  position: relative;
}

.apply-coupan-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  cursor: pointer;
  z-index: 999;
}

.apply-coupan-btn.offer-apply-coupan-btn {
  top: 16px;
  right: 20px;
}

/* .offer-apply-coupan-btn{
  position: unset;
} */

.apply-coupan-btn button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 86px;
  background: #f3f3f3;
  min-height: 36px;
  font-size: 14px;
  font-weight: 600;
  color: #00a19b;
  cursor: pointer;
  border: none;
  border-radius: 9px;
}

.apply-coupan-btn button:hover{
  background: #00a19b;
  color: #f3f3f3;
}

.offer-apply-coupan-btn.disabled button:hover{
  color: #bebebe;
  background: #fff;
}



button.remove-coupon {
  color: #ff0000;
  padding: 0px 20px;
}

.offer-apply-coupan-btn button {
  background: #fff;
}

.coupan-more-offers-wrap {
  margin-top: 45px;
}

.coupan-more-offers-wrap h5 {
  font-size: 16px;
  margin: 0px;
  font-weight: 500;
}

.more-offer-repeat {
  margin-top: 20px;
}

.more-offer-card-wrap {
  position: relative;
  width: 100%;
  height: 148px;
  background: #f3f3f3;
  padding: 20px;
  display: flex;
  gap: 20px;
  /* justify-content: space-between; */
  border-radius: 26px;
}

.coupan-code-wrap {
  display: flex;
  align-items: center;
  gap: 0px;
}

.coupan-code-wrap img {
  width: 40px;
  margin-right: 5px;
}

.coupan-code-wrap h5 {
  font-size: 14px;
  margin: 0px;
  font-weight: 500;
  color: #1a1919;
}

.coupan-offer-desc-wrap {
  margin-top: 10px;
  margin-left: 4px;
}

.coupan-offer-desc-wrap h6 {
  font-size: 12px;
  margin: 0px;
  font-weight: 400;
  color: #1a1919;
  width: 70%;
}

.coupan-offer-desc-wrap p {
  font-size: 12px;
  color: #878787;
  margin: 0px;
  font-weight: 400;
  padding-top: 14px;
}

.coupan-subtract-wrap svg {
  margin-top: -20px;
  margin-left: -30px;
}

.coupan-subtract-wrap h3 {
  font-size: 18px;
  color: #ffffff;
  font-weight: bold;
  margin: 0px;
  position: absolute;
  top: 10px;
  left: 0;
}

.discount-top-left {
  font-size: 18px;
  color: #ffffff;
  font-weight: bold;
  margin: 0px;
  position: absolute;
  top: 30px;
  left: 6px;
  transform: rotate(-90deg) scaleX(-1);
  transform-origin: top left;

  .content {
    transform: scaleX(-1);
  }
}

.coupan-subtract-wrap.disabled svg path {
  fill: #bebebe;
}

.offer-apply-coupan-btn.disabled button {
  color: #bebebe;
  font-weight: 500;
  cursor: default;
}

/********* Postpaid drawer css ******/

.postpaid-drawer-main-header {
  margin-bottom: 15px;
}

.postpaid-contant-wrap p {
  font-size: 14px;
  font-weight: 500;
  margin: 0px;
  color: #1a1919;
  width: 90%;
}

.postpaid-detail-repeat {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #c5c5c5;
  height: 80px;
  opacity: 0.4;
}

.postpaid-detail-repeat h3 {
  font-size: 14px;
  color: #1a1919;
  font-weight: 600;
  margin: 0px;
}

.postpaid-main-wrap {
  margin-top: 150px;
}

.postpaid-main-wrap p {
  font-size: 14px;
  color: #1a1919;
  font-weight: 400;
  margin: 0px;
  padding-bottom: 40px;
}

.postpaid-detail-repeat.active {
  opacity: 1;
}

.postpaid-submit-btn {
  width: 100%;
  position: absolute;
  bottom: 0px;
}

.postpaid-submit-btn button {
  height: 49px;
}

.postpaid-status-main-wrap {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  height: calc(100vh - 200px);
}


.postpaid-status-image img{
  width: 190px;
}

.postpaid-status-image img.postpaid-reject-image{
  width: 125px;
}

.postpaid-status-image img.postpaid-approved-image{
  width: 150px;
}

.postpaid-status-image{
  padding-bottom: 25px;
}

.postpaid-status-content-wrap h3 {
  font-size: 16px;
  color: #1A1919;
  font-weight: 600;
  margin: 0px;
  padding-bottom: 25px;
}

.postpaid-status-content-wrap p {
  font-size: 14px;
  color: #1A1919;
  font-weight: 400;
  margin: 0px;
  width: 380px;
}


/********** Cart Drawer css ********/
.cart-drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: -16px;
  background: #fff;
}

.cart-drawer-header h3 {
  font-size: 24px;
  color: #1a1919;
  font-weight: 600;
  margin: 0px;
}

.cart-drawer-retail-wrap h4 {
  font-size: 18px;
  color: #1a1919;
  font-weight: 600;
  margin: 0px;
  margin-bottom: 22px;
}

.cart-square-feet-wrap p {
  font-size: 16px;
  color: #1a1919;
  font-weight: 400;
  margin: 0px;
}

.cart-square-feet-wrap span {
  font-size: 18px;
  color: #1a1919;
  font-weight: 400;
  margin: 0px;
}

.cart-drawer-retail-wrap {
  display: flex;
  align-items: center;
  gap: 28px;
  margin-top: 70px;
}

.cart-square-image img {
  width: 110px;
}

.cart-total-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
}

.cart-total-wrap h3 {
  font-size: 20px;
  color: #1a1919;
  font-weight: 600;
  margin: 0px;
}

.cart-total-wrap h4 {
  font-size: 20px;
  color: #00a19b;
  font-weight: 600;
  margin: 0px;
}

.cart-booking-wrapper {
  width: 650px;
  position: fixed;
  bottom: 40px;
  background: #ffff;
}

.cart-drawer-main-wrapper .booking-cart-items-wrap h5 {
  font-size: 18px;
}

.cart-drawer-main-wrapper .booking-item-detail h6 {
  font-size: 18px;
}

.cart-drawer-main-wrapper .booking-item-detail p {
  font-size: 18px;
}

.cart-drawer-main-wrapper .booking-item-detail span {
  font-size: 18px;
}

.cart-drawer-main-wrapper .booking-item-image {
  width: 28px;
  height: 28px;
}

.cart-drawer-main-wrapper .update-quantity-btn {
  min-width: 110px;
  padding: 5px 10px;
  border-radius: 17px;
}

.cart-drawer-main-wrapper .update-quantity-btn span {
  text-align: center;
  font-size: 16px;
  width: 20px;
}

.cart-drawer-main-wrapper span.percentage-text {
  width: 40px;
  text-align: center;
}

.cart-drawer-main-wrapper .update-quantity-btn h4 {
  font-size: 22px;
  width: 16px;
  text-align: center;
}

.cart-drawer-main-wrapper .booking-item-price-wrap p {
  font-size: 18px;
  min-width: 80px;
}

.cart-drawer-main-wrapper .booking-cart-item-right {
  gap: 26px;
}

.cart-drawer-main-wrapper .edit-extra-item-btn {
  min-width: 105px;
  padding: 5px;
  border-radius: 17px;
}

.drawer-close-icon-wrap img {
  width: 38px;
  cursor: pointer;
}

.history-centered-icon {
  text-align: center;
}

.cart-drawer-main-wrap .booking-item-price-wrap {
  display: none;
}

.drawer-close-icon-wrap:hover img {
  transform: scale(0.9);
}

.drawer-close-icon:hover img {
  transform: scale(0.9);
}

.close-icon-wrap:hover img {
  transform: scale(0.9);
}

.login-option.addtional-drawer-squirefeet-input .field label::before {
  left: 15px !important;
}

.flooring-dropdown-toggle-wrapper {
  margin-top: 23px;
}

.flooring-dropdown-toggle-wrapper h3 {
  font-size: 14px;
  color: #1a1919;
  font-weight: 600;
  margin: 0px;
}

.flooring-dropdown-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 18px;
}

.flooring-toggle-left {
  width: 140px;
  height: 40px;
  border: 1px solid #f3f3f3;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.flooring-toggle-left p {
  font-size: 14px;
  color: #a2a2a2;
  font-weight: 400;
  margin: 0px;
}

.flooring-toggle-left.active {
  border: 1px solid #00a19b;
}

.flooring-toggle-left.active p {
  color: #00a19b;
}

.chat-date-divider {
  width: 80%;
  border: 1px solid #e9e9e9;
  height: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  margin-top: 26px;
  margin-bottom: 34px;
}

.chat-date-divider span {
  display: block;
  background: #fff;
  padding: 0px 20px;
  color: #b5b5b5;
  font-size: 14px;
  font-weight: 400;
}

.noting-found-main-wrap img {
  width: 112px;
  margin-bottom: 10px;
}

.noting-found-main-wrap p {
  font-size: 24px;
  color: #b2b2b2;
  margin: 0px;
  font-weight: 400;
}

.noting-found-main-wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 200px);
}

.nothing-found-cart-wrap {
  height: calc(100vh - 210px);
}

.history-centered-icon.history-status-image img {
  width: 30px;
  margin-left: -20px;
}

input.error-msg.placeholder-error-text::placeholder {
  color: #ff0000;
}

img.disable-button {
  opacity: 0.5;
  cursor: no-drop;
}

.notification-item-staticImg {
  width: 55px;
  margin-left: -14px !important;
}

.notification-item-staticImg img {
  width: 100%;
}

.addcard-main-wrapper {
  width: 100%;
  margin: 0 auto;
  padding: 40px 20px;
  /* background-color: #f9f9f9; */
  border-radius: 20px;
  border: 2px solid #f8f8f8;
  margin-top: 50px;
}

.addcard-main-wrapper form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.addcard-main-wrapper .form-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.addcard-main-wrapper .form-group label {
  font-size: 14px;
  font-weight: 500;
  color: #1a1919;
  font-family: "Montserrat";
  margin-left: 10px;
}

.custom-stripe-input {
  border: 1px solid #f3f3f3;
  border-radius: 9px;
  padding: 20px 10px;
  font-weight: 500;
  background-color: #fff;
}

.save-card-btn button {
  height: 49px;
  margin-top: 20px;
}

.contractor-certificate-wrapper {
  margin-top: 50px;
}

p.postpaid-info-content {
  font-size: 14px;
  color: #1a1919;
  font-weight: 400;
  margin: 0px;
  padding-bottom: 20px;
}

p.uploaded-pdf {
  color: #0d6efd !important;
  font-style: italic;
}

.contractor-certificate-wrap {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.certificate-upload-box {
  border: 1px solid #f3f3f3;
  border-radius: 9px;
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px;
  position: relative;
}

.certificate-upload-box input {
  width: 40px;
  opacity: 0;
  position: absolute;
  cursor: pointer;
}

.certificate-upload-box p {
  font-size: 14px;
  color: #1a1919;
  font-weight: 400;
  white-space: nowrap;
  margin: 0px;
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}

p.check-path-text {
  font-style: italic;
  color: #0f0fd5;
}

.upload-lable.active {
  background: #fff;
  position: absolute;
  top: -10px;
  width: auto;
  left: 15px;
  padding: 0px 5px;
}

.upload-icon-wrap img {
  width: 24px;
  cursor: pointer;
}

.contractor-certificate-wrap {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

span.postpaid-status-Rejected {
  margin-left: 10px;
  color: #ff0000;
}

span.postpaid-status-Pending {
  margin-left: 10px;
}

h3.multi-addition-main-title {
  font-size: 16px;
  margin-top: 20px;
  font-weight: 600;
  margin-left: 10px;
  color: #00a19b;
}

.additional-add-item-btn {
  text-align: right;
  margin-top: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: right;
}

.additional-add-item-btn button {
  background: #00a19b;
  width: 100px;
  color: #fff;
}

.selected-items-list {
  margin-top: 30px;
}

.selected-items-list h3 {
  font-size: 16px;
  font-weight: 600;
}

.selected-items-list .selected-item {
  font-size: 14px;
  margin-bottom: 10px;
}

.selected-items-list span.delete-item-icon {
  margin: 0px;
  width: 19px;
  height: 19px;
  border-radius: 50%;
  background: #d3e9e9;
  color: #00a19b;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
}

.selected-items-list span.delete-item-icon {
  margin-top: 2px;
}

p.error-msg.postpaid-error-msg{
  margin-top: 10px;
}

.additional-sqfeet-wrap{
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
}


.additional-sqfeet-wrap img{
  cursor: pointer;
}

.additional-sqfeet-wrap p{
  margin: 0px;
}


.booking-view-icon{
  text-align: right;
  margin-top: 10px;
}

.booking-view-icon img{
  width: 30px;
  cursor: pointer;
}

.booking-view-icon img:hover{
  scale: 0.9;
}

img.table-view-icon:hover{
  scale: 0.9;
}

/******* Resposive css ****/
@media (max-width: 1024px) {
  .history-offcanvas-wrapper.offcanvas.offcanvas-end.show {
    width: 100%;
    box-shadow: -5px 0px 14px #0000000d;
    border-radius: 0px;
    padding: 30px 0px 30px 0px;
    z-index: 99999;
  }

  .drawer-main-header-wrap h4 {
    font-size: 22px;
  }

  .items-hold-wrap p {
    width: 80px;
    font-size: 14px;
  }

  .items-hold-wrap span {
    font-size: 14px;
  }

  .history-list-drawer-table .table tbody tr td {
    color: #717171;
    font-size: 14px;
  }

  .table-view-icon-wrap {
    text-align: center;
    margin-left: -20px;
  }

  .table-view-icon-wrap img {
    width: 35px;
  }

  .history-list-drawer-table .table tbody tr:first-child td {
    padding-top: 12px;
  }

  .history-list-drawer-table .table.table-hover thead th {
    color: #383838;
    font-size: 16px;
    font-weight: 600;
    padding-top: 12px;
    padding-bottom: 12px;
  }

  .history-list-drawer-table thead th:first-child {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }

  .history-list-drawer-table thead th:last-child {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  .history-offcanvas-wrapper .offcanvas-body {
    padding: 0px !important;
  }

  .extras-offcanvas-wrapper.offcanvas.offcanvas-end.show {
    width: 100%;
    padding: 30px 0px 0px 20px;
  }

  .postpaid-offcanvas-wrapper.offcanvas.offcanvas-end.show {
    padding: 30px 30px 0px 30px;
  }

  .extras-offcanvas-wrapper .offcanvas-body {
    padding-bottom: 0px;
  }

  .addition-drawer-main-wrap {
    padding-right: 30px;
  }

  .extra-drawer-main-header {
    padding-right: 30px;
  }

  .extra-addto-cart-btn {
    padding-right: 30px;
  }

  .extra-drawer-main-wrapper {
    /* padding-right: 20px; */
    /* min-height: calc(100vh - 160px); */
  }

  .extra-drawer-size-wrap {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: flex-start;
    margin-top: 10px;
  }
  .extra-drawer-size-repeat {
    display: flex;
    gap: 10px;
  }

  .extra-drawer-main-header h4 {
    font-size: 22px;
  }

  .extra-back-wrap img {
    width: 8px;
  }

  .extra-category-dropdown-wrap {
    margin-top: 40px;
  }

  /* .extra-addto-cart-btn {
  padding-right: 20px;
  bottom: 0px;
} */

  button.add-to-cart-btn {
    height: 62px;
    font-size: 16px;
  }

  .extra-back-wrap img {
    display: none;
  }

  .postpaid-contant-wrap p {
    font-size: 14px;
    width: 100%;
  }

  .postpaid-main-wrap {
    margin-top: 50px;
  }

  .postpaid-main-wrap p {
    padding-bottom: 10px;
  }

  .postpaid-detail-repeat {
    height: 70px;
  }

  .postpaid-submit-btn {
    padding-right: 20px;
  }

  .postpaid-submit-btn button {
    height: 62px;
  }

  .coupon-offcanvas-wrapper.offcanvas.offcanvas-end.show {
    width: 100%;
    padding: 20px 0px 30px 26px;
  }

  .coupon-offcanvas-wrapper .extra-drawer-main-wrapper {
    padding-right: 14px;
  }

  .coupan-more-offers-wrap h5 {
    font-size: 14px;
  }

  .coupan-offer-desc-wrap {
    width: 100%;
  }

  .more-offer-card-wrap {
    border-radius: 14px;
    gap: 14px;
  }

  .chat-offcanvas-wrapper.offcanvas.offcanvas-end.show {
    width: 100%;
    border-radius: 0px;
    padding: 20px 0px 10px 26px;
  }

  .chat-offcanvas-wrapper .offcanvas-body {
    padding-right: 0px;
  }

  .chat-offcanvas-wrapper .notification-drawer-header {
    padding-right: 26px;
    padding-bottom: 0px;
  }

  .notification-drawer-header {
    padding-bottom: 20px;
  }

  .notification-drawer-header h3 {
    font-size: 22px;
  }

  .empty-conversation-wrap h3 {
    font-size: 16px;
  }

  .empty-conversation-wrap p {
    font-size: 14px;
    width: 88%;
  }

  .msger-chat {
    padding: 0px;
    padding-right: 26px;
    height: calc(100vh - 240px);
  }

  .chat-drawer-main-wrap .chat-send-message-wrapper {
    padding-right: 26px;
  }

  .chat-send-message-wrap input {
    width: 100%;
    height: 72px;
  }

  .chat-send-button img {
    width: 52px;
  }

  .cleaner-partner.left {
    font-size: 16px;
  }

  .msg-bubble {
    max-width: 450px;
    padding: 12px 25px;
  }

  .right-info-time p,
  .left-info-time p {
    font-size: 14px;
    font-weight: 400;
    padding-top: 4px;
    margin-left: 18px;
    margin-right: 18px;
  }

  .replay-chat-box-wrapper {
    height: calc(100vh - 170px);
  }

  .chat-send-message-wrapper {
    padding-right: 24px;
  }

  .write-review-wrapper textarea {
    border: 1px solid #f3f3f3;
    border-radius: 13px;
    width: 100%;
  }

  .trackorder-offcanvas-wrapper.offcanvas.offcanvas-end.show {
    /* width: 725px; */
    width: 600px;
    box-shadow: -5px 0px 14px #0000000d;
    border-radius: 0px;
    padding: 40px 10px 10px 20px;
    z-index: 9999;
  }

  .trackorder-offcanvas-wrapper .book-button-wrapper {
    margin-top: 14px;
  }

  .trackorder-offcanvas-wrapper .order-track-text {
    width: 100%;
  }

  .write-review-wrapper textarea {
    width: 100% !important;
  }

  .track-close-icon-wrap {
    position: absolute;
    right: 30px;
  }

  .track-close-icon-wrap img {
    width: 38px;
    cursor: pointer;
  }

  .order-track-status-line {
    height: 100px;
  }

  .order-cance-btn {
    width: 100%;
  }

  .cancel-order-main-wrap {
    bottom: 30px !important;
    padding-left: 30px;
    padding-right: 20px;
  }

  button.cancel-order-button {
    width: 100%;
  }

  .cancel-order-info {
    align-items: baseline !important;
  }

  .noting-found-main-wrap img {
    width: 90px;
    margin-bottom: 10px;
  }

  .noting-found-main-wrap p {
    font-size: 20px;
  }

  .postpaid-status-content-wrap p {
    width: unset;
  }
}

@media (max-width: 360px) {
  .coupon-offcanvas-wrapper.offcanvas.offcanvas-end.show {
    width: 100%;
    padding: 20px 0px 30px 22px;
  }

  .coupon-offcanvas-wrapper .extra-drawer-main-wrapper {
    padding-right: 12px;
  }

  .more-offer-card-wrap {
    gap: 10px;
  }

  .apply-coupan-btn.offer-apply-coupan-btn {
    right: 14px;
  }

  .postpaid-main-wrap {
    margin-top: 40px;
  }

  .coupan-code-wrap img {
    width: 24px;
    margin-right: 2px;
  }

  .postpaid-detail-repeat {
    height: 60px;
  }
}

@media (max-width: 330px) {
  .coupon-offcanvas-wrapper.offcanvas.offcanvas-end.show {
    width: 100%;
    padding: 20px 0px 20px 10px;
  }

  .coupon-offcanvas-wrapper .extra-drawer-main-wrapper {
    padding-right: 0px;
  }

  .more-offer-card-wrap {
    gap: 6px;
  }

  .apply-coupan-btn.offer-apply-coupan-btn {
    right: 14px;
  }

  .coupan-code-wrap img {
    width: 24px;
    margin-right: 2px;
  }

  .extra-drawer-main-header h4 {
    font-size: 20px;
  }

  .postpaid-detail-repeat {
    height: 56px;
  }
}
/* 
@media (min-width: 768px) and (max-width: 1024px) {
  .history-offcanvas-wrapper.offcanvas.offcanvas-end.show {
    width: 710px;
    padding: 20px 0px 30px 30px;
  }

  .history-item-images-wrapper img.main-image {
    display: none;
  }

  .history-item-image-box {
    width: 30px;
    border-radius: 50%;
    margin-left: -12px;
  }

  .items-hold-wrap span {
    font-size: 16px;
  }

  .history-list-drawer-table .table tbody tr td {
    font-size: 16px;
  }

  .history-list-drawer-table .table.table-hover thead th {
    font-size: 16px;
    padding-left: 20px;
  }

.history-centered-icon img {
  width: 30px;
  margin-left: -10px;
}

.drawer-main-header-wrap h4 {
  font-size: 22px;
}

.drawer-close-icon img {
  width: 34px;
}

.drawer-main-header-wrap {
  margin-bottom: 28px;
  padding-left: 18px;
  padding-right: 20px;
}

.items-hold-wrap p {
  width: 60px;
}


.coupon-offcanvas-wrapper.offcanvas.offcanvas-end.show {
  width: 500px;
}

.extras-offcanvas-wrapper.offcanvas.offcanvas-end.show {
  width: 520px;
  padding: 30px 30px 30px 30px;
}

.extra-drawer-size {
  width: 130px;
}

.postpaid-main-wrap {
  margin-top: 50px;
}

.postpaid-detail-repeat {
  height: 70px;
}

.postpaid-main-wrap p {
  padding-bottom: 20px;
}

.cart-total-wrap {
  margin-bottom: 20px;
}

.cart-total-wrap h3 {
  font-size: 18px;
}

.cart-total-wrap h4 {
  font-size: 18px;
}


.cart-offcanvas-wrapper.offcanvas.offcanvas-end.show {
  width: 650px;
  padding: 20px 20px 180px 30px;
}

.cart-booking-wrapper {
  width: 550px;
}

.cart-drawer-main-wrap .booking-cart-item-repeat{
  flex-direction: row;
}

.cart-drawer-main-wrapper h6.flooring-cat {
  display: block;
}


.cart-drawer-retail-wrap h4 {
  font-size: 16px;
  margin-bottom: 10px;
}

.cart-square-image img {
  width: 80px;
}

.cart-drawer-main-wrapper .booking-item-detail h6 {
  font-size: 16px;
}

.cart-drawer-main-wrapper .booking-item-detail p {
  font-size: 16px;
}

.cart-drawer-main-wrapper .booking-item-detail span {
  font-size: 16px;
}

.cart-drawer-main-wrapper .booking-cart-item-right {
  gap: 10px;
}

.cart-drawer-main-wrapper .update-quantity-btn span {
  font-size: 14px;
}

.cart-drawer-main-wrapper .booking-item-price-wrap p {
  font-size: 16px;
  min-width: 70px;
}

.cart-drawer-retail-wrap {
  margin-top: 30px;
}

.notification-offcanvas-wrapper.offcanvas.offcanvas-end.show {
  width: 640px;
  padding: 30px 20px 30px 30px
}

.notification-drawer-header h3 {
  font-size: 22px;
}

.drawer-close-icon-wrap img {
  width: 34px;
}

.notification-drawer-header {
    padding-bottom: 20px;
}

.notification-title-wrap h4 {
  font-size: 16px;
}

.notification-item-image {
  width: 32px;
}

.notification-order-repeat {
  margin-top: 40px;
}

.chat-offcanvas-wrapper.offcanvas.offcanvas-end.show {
  width: 560px;
}

.cleaner-partner.left {
  font-size: 14px;
  margin-left: 10px;
}

.replay-chat-box-wrap .msg.left-msg .msg-text {
  font-size: 14px;
}

.replay-chat-box-wrap .msg .msg-text {
  font-size: 14px;
}

.msg-bubble {
  padding: 10px 16px;
}

.right-info-time p, .left-info-time p {
    font-size: 12px;
    font-weight: 400;
    padding-top: 2px;
    margin-left: 15px;
    margin-right: 15px;
}

.chat-send-message-wrap input {
  height: 68px;
}

.chat-send-button img {
  width: 54px;
  top: 8px;
}

.trackorder-offcanvas-wrapper.offcanvas.offcanvas-end.show {
  width: 500px;
  box-shadow: -5px 0px 14px #0000000D;
  border-radius: 34px 0px 0px 34px;
  padding: 20px 0px 40px 40px;
  z-index: 99999;
}

.cancel-order-main-wrap {
  left: 40px;
  right: 30px;
  bottom: 40px;
}

.track-close-icon-wrap {
  position: absolute;
  right: 30px;
}

.track-close-icon-wrap img{
  width: 34px;
  cursor: pointer;
}

.fade.modal.show {
  z-index: 999999;
}

} */

@media (min-width: 1025px) and (max-width: 1199px) {
  .history-offcanvas-wrapper.offcanvas.offcanvas-end.show {
    width: 680px;
    padding: 20px 0px 30px 30px;
  }

  .history-item-images-wrapper img.main-image {
    display: none;
  }

  .history-item-image-box {
    width: 30px;
    border-radius: 50%;
    margin-left: -12px;
  }

  .items-hold-wrap span {
    font-size: 16px;
  }

  .history-list-drawer-table .table tbody tr td {
    font-size: 16px;
  }

  .history-list-drawer-table .table.table-hover thead th {
    font-size: 16px;
    padding-left: 20px;
  }

  .history-centered-icon img {
    width: 30px;
    margin-left: -10px;
  }

  .drawer-main-header-wrap h4 {
    font-size: 22px;
  }

  .drawer-close-icon img {
    width: 34px;
  }

  .drawer-main-header-wrap {
    margin-bottom: 28px;
    padding-left: 18px;
    padding-right: 20px;
  }

  .items-hold-wrap p {
    width: 60px;
  }

  .coupon-offcanvas-wrapper.offcanvas.offcanvas-end.show {
    width: 500px;
  }

  .extras-offcanvas-wrapper.offcanvas.offcanvas-end.show {
    width: 520px;
    padding: 30px 0px 0px 30px;
  }

  .postpaid-offcanvas-wrapper.offcanvas.offcanvas-end.show {
    padding: 30px 30px 0px 30px;
  }

  .extras-offcanvas-wrapper .offcanvas-body {
    padding-bottom: 0px;
    /* padding-right: 30px; */
  }

  .addition-drawer-main-wrap {
    padding-right: 30px;
  }

  .extra-drawer-main-header {
    padding-right: 30px;
  }

  .extra-addto-cart-btn {
    padding-right: 30px;
  }

  .extra-drawer-size {
    width: 130px;
  }

  .postpaid-main-wrap {
    margin-top: 50px;
  }

  .postpaid-detail-repeat {
    height: 70px;
  }

  .postpaid-main-wrap p {
    padding-bottom: 20px;
  }

  .cart-drawer-main-wrapper .booking-item-image {
    width: 26px;
    height: 26px;
  }

  .booking-cart-item-left {
    gap: 8px;
  }

  .cart-total-wrap {
    margin-bottom: 20px;
  }

  .cart-total-wrap h3 {
    font-size: 18px;
  }

  .cart-total-wrap h4 {
    font-size: 18px;
  }

  .cart-offcanvas-wrapper.offcanvas.offcanvas-end.show {
    width: 620px;
    padding: 20px 0px 110px 50px;
  }

  .cart-offcanvas-wrapper .cart-drawer-main-wrap {
    padding-right: 30px;
  }

  .cart-offcanvas-wrapper.offcanvas-body {
    padding: 0px;
  }

  .cart-offcanvas-wrapper .cart-button-wrap {
    padding-right: 30px;
  }

  .cart-drawer-header {
    background: #fff;
    padding-bottom: 10px;
  }

  .cart-booking-wrapper {
    width: 540px;
  }

  .cart-drawer-main-wrap .booking-cart-item-repeat {
    flex-direction: row;
  }

  .cart-drawer-main-wrapper h6.flooring-cat {
    display: block;
  }

  .cart-drawer-retail-wrap h4 {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .cart-square-image img {
    width: 80px;
  }

  .cart-drawer-main-wrapper .booking-item-detail h6 {
    font-size: 16px;
  }

  .cart-drawer-main-wrapper .booking-item-detail p {
    font-size: 16px;
  }

  .cart-drawer-main-wrapper .booking-item-detail span {
    font-size: 16px;
  }

  .cart-drawer-main-wrapper .booking-cart-item-right {
    gap: 10px;
  }

  .cart-drawer-main-wrapper .update-quantity-btn span {
    font-size: 14px;
  }

  .cart-drawer-main-wrapper .booking-item-price-wrap p {
    font-size: 16px;
    min-width: 70px;
  }

  .cart-drawer-retail-wrap {
    margin-top: 30px;
  }

  .notification-offcanvas-wrapper.offcanvas.offcanvas-end.show {
    width: 560px;
    padding: 30px 0px 30px 60px;
  }

  .notification-drawer-header h3 {
    font-size: 22px;
  }

  .drawer-close-icon-wrap img {
    width: 34px;
  }

  .notification-drawer-header {
    padding-bottom: 10px;
    padding-top: 10px;
  }

  .notification-title-wrap h4 {
    font-size: 16px;
  }

  .notification-item-image {
    width: 32px;
  }

  .notification-order-repeat {
    margin-top: 30px;
  }

  .notification-date-wrap {
    padding-top: 30px;
  }

  .chat-offcanvas-wrapper.offcanvas.offcanvas-end.show {
    width: 560px;
  }

  .cleaner-partner.left {
    font-size: 14px;
    margin-left: 10px;
  }

  .replay-chat-box-wrap .msg.left-msg .msg-text {
    font-size: 14px;
  }

  .replay-chat-box-wrap .msg .msg-text {
    font-size: 14px;
  }

  .msg-bubble {
    padding: 10px 16px;
  }

  .right-info-time p,
  .left-info-time p {
    font-size: 12px;
    font-weight: 400;
    padding-top: 2px;
    margin-left: 15px;
    margin-right: 15px;
  }

  .chat-send-message-wrap input {
    height: 68px;
  }

  .chat-send-button img {
    width: 54px;
    top: 8px;
  }

  .replay-chat-box-wrapper {
    height: calc(100vh - 120px);
  }

  .noting-found-main-wrap img {
    width: 90px;
    margin-bottom: 10px;
  }

  .noting-found-main-wrap p {
    font-size: 20px;
  }

  .apply-coupan-btn {
    top: 6px;
  }
}

@media (min-width: 1200px) and (max-width: 1599px) {
  .items-hold-wrap p {
    width: 60px;
  }

  .history-offcanvas-wrapper.offcanvas.offcanvas-end.show {
    width: 52%;
    padding: 20px 0px 30px 30px;
  }

  .history-item-images-wrapper img.main-image {
    display: none;
  }

  .history-item-image-box {
    width: 30px;
    border-radius: 50%;
    margin-left: -12px;
  }

  .items-hold-wrap span {
    font-size: 16px;
  }

  .history-list-drawer-table .table tbody tr td {
    font-size: 16px;
  }

  .history-list-drawer-table .table.table-hover thead th {
    font-size: 16px;
    padding-left: 25px;
  }

  .history-centered-icon img {
    width: 30px;
  }

  .drawer-main-header-wrap h4 {
    font-size: 22px;
  }

  .drawer-close-icon img {
    width: 34px;
  }

  .drawer-main-header-wrap {
    margin-bottom: 28px;
    padding-left: 18px;
    padding-right: 20px;
  }

  .coupon-offcanvas-wrapper.offcanvas.offcanvas-end.show {
    width: 500px;
  }

  .extras-offcanvas-wrapper.offcanvas.offcanvas-end.show {
    width: 520px;
    padding: 30px 0px 0px 30px;
  }

  .postpaid-offcanvas-wrapper.offcanvas.offcanvas-end.show {
    padding: 30px 40px 0px 40px;
  }

  .extras-offcanvas-wrapper .offcanvas-body {
    padding-bottom: 0px;
    /* padding-right: 30px; */
  }

  .addition-drawer-main-wrap {
    padding-right: 30px;
  }

  .extra-drawer-main-header {
    padding-right: 30px;
  }

  .extra-addto-cart-btn {
    padding-right: 30px;
  }

  .extra-drawer-size {
    width: 130px;
  }

  .postpaid-main-wrap {
    margin-top: 50px;
  }

  .postpaid-detail-repeat {
    height: 70px;
  }

  .postpaid-main-wrap p {
    padding-bottom: 20px;
  }

  .cart-offcanvas-wrapper.offcanvas.offcanvas-end.show {
    width: 620px;
    padding: 20px 0px 110px 50px;
  }

  .cart-offcanvas-wrapper .cart-drawer-main-wrap {
    padding-right: 30px;
  }

  .cart-offcanvas-wrapper.offcanvas-body {
    padding: 0px;
  }

  .cart-offcanvas-wrapper .cart-button-wrap {
    padding-right: 30px;
  }

  .extras-offcanvas-wrapper.active.offcanvas.offcanvas-end.show {
    width: 640px;
  }

  .cart-booking-wrapper {
    width: 540px;
    bottom: 26px;
  }

  .cart-drawer-main-wrapper .booking-item-image {
    width: 26px;
    height: 26px;
  }

  .booking-cart-item-left {
    gap: 8px;
  }

  .cart-total-wrap {
    margin-bottom: 20px;
  }

  .cart-total-wrap h3 {
    font-size: 18px;
  }

  .cart-total-wrap h4 {
    font-size: 18px;
  }

  .cart-drawer-main-wrap .booking-cart-item-repeat {
    flex-direction: row;
  }

  .cart-drawer-retail-wrap h4 {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .cart-square-image img {
    width: 80px;
  }

  .cart-drawer-main-wrapper .booking-item-detail h6 {
    font-size: 16px;
  }

  .cart-drawer-main-wrapper .booking-item-detail p {
    font-size: 16px;
  }

  .cart-drawer-main-wrapper .booking-item-detail span {
    font-size: 16px;
  }

  .cart-drawer-main-wrapper .booking-cart-item-right {
    gap: 10px;
  }

  .cart-drawer-main-wrapper .update-quantity-btn span {
    font-size: 14px;
  }

  .cart-drawer-main-wrapper .booking-item-price-wrap p {
    font-size: 16px;
    min-width: 70px;
  }

  .cart-drawer-retail-wrap {
    margin-top: 30px;
  }

  .notification-offcanvas-wrapper.offcanvas.offcanvas-end.show {
    width: 600px;
    padding: 30px 0px 30px 70px;
  }

  .notification-date-wrap {
    padding-top: 30px;
  }

  .notification-drawer-header h3 {
    font-size: 22px;
  }

  .drawer-close-icon-wrap img {
    width: 34px;
  }

  .notification-drawer-header {
    padding-bottom: 10px;
  }

  .notification-title-wrap h4 {
    font-size: 16px;
  }

  .notification-item-image {
    width: 32px;
  }

  .notification-order-repeat {
    margin-top: 34px;
  }

  .chat-offcanvas-wrapper.offcanvas.offcanvas-end.show {
    width: 560px;
  }

  .cleaner-partner.left {
    font-size: 14px;
    margin-left: 10px;
  }

  .replay-chat-box-wrap .msg.left-msg .msg-text {
    font-size: 14px;
  }

  .replay-chat-box-wrap .msg .msg-text {
    font-size: 14px;
  }

  .msg-bubble {
    padding: 10px 16px;
  }

  .right-info-time p,
  .left-info-time p {
    font-size: 12px;
    font-weight: 400;
    padding-top: 2px;
    margin-left: 15px;
    margin-right: 15px;
  }

  .chat-send-message-wrap input {
    height: 68px;
  }

  .chat-send-button img {
    width: 54px;
    top: 8px;
  }

  .apply-coupan-btn {
    position: absolute;
    top: 6px;
    right: 8px;
  }

  .coupan-more-offers-wrap {
    margin-top: 30px;
  }

  .apply-coupan-btn button {
    font-size: 13px;
  }

  .replay-chat-box-wrapper {
    height: calc(100vh - 130px);
  }

  .noting-found-main-wrap img {
    width: 100px;
    margin-bottom: 10px;
  }

  .noting-found-main-wrap p {
    font-size: 22px;
  }
}

@media (min-width: 1600px) {
  .cart-drawer-main-wrap {
    padding-right: 40px;
  }
}

@media (min-width: 2000px) {
  .history-centered-icon {
    text-align: center;
    margin-left: -20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/drawers/drawer.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,mCAAmC;EACnC,gCAAgC;EAChC,2BAA2B;EAC3B,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,8BAA8B;EAC9B,8BAA8B;EAC9B,0BAA0B;EAC1B,cAAc;EACd,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,8BAA8B;EAC9B,8BAA8B;EAC9B,4BAA4B;EAC5B,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,gCAAgC;EAChC,2BAA2B;EAC3B,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,gCAAgC;EAChC,4BAA4B;EAC5B,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,gCAAgC;EAChC,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;;;;;;EAME,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;;;KAKK;;AAEL;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,MAAM;EACN,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;GAGG;;AAEH;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;;;;GAIG;;AAEH;EACE,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA,gCAAgC;;AAEhC;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;;;AAIA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,SAAS;EACT,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,oCAAoC;EACpC,0BAA0B;;EAE1B;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,qCAAqC;;AAErC;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;AAC7B;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;;AAGA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;;AAGA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE;IACE,WAAW;IACX,mCAAmC;IACnC,kBAAkB;IAClB,0BAA0B;IAC1B,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,qCAAqC;EACvC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;GAGC;;EAED;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,mCAAmC;IACnC,kBAAkB;IAClB,4BAA4B;IAC5B,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAmPG;;AAEH;EACE;IACE,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF","sourcesContent":[".history-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n  width: 50%;\r\n  box-shadow: -5px 0px 14px #0000000d;\r\n  border-radius: 34px 0px 0px 34px;\r\n  padding: 20px 0px 40px 40px;\r\n  z-index: 99999;\r\n  border: none;\r\n}\r\n\r\n.extras-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n  width: 620px;\r\n  box-shadow: -5px 0px 14px #0000000d;\r\n  border-radius: 0px 0px 0px 0px;\r\n  border-left: 5px solid #00a19b;\r\n  padding: 30px 0px 0px 40px;\r\n  z-index: 99999;\r\n  border: none;\r\n}\r\n\r\n.postpaid-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n  padding: 30px 40px 0px 40px;\r\n}\r\n\r\n.postpaid-offcanvas-wrapper .extra-drawer-main-header {\r\n  padding-right: 0px;\r\n}\r\n\r\n.extras-offcanvas-wrapper .offcanvas-body {\r\n  padding-bottom: 0px;\r\n  padding-right: 0px;\r\n}\r\n\r\n.addition-drawer-main-wrap {\r\n  height: calc(100vh - 200px);\r\n  padding-right: 40px;\r\n  overflow: auto;\r\n}\r\n\r\n.extras-offcanvas-wrapper.active.offcanvas.offcanvas-end.show {\r\n  width: 775px;\r\n}\r\n\r\n.coupon-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n  width: 530px;\r\n  box-shadow: -5px 0px 14px #0000000d;\r\n  border-radius: 0px 0px 0px 0px;\r\n  border-left: 5px solid #00a19b;\r\n  padding: 20px 26px 40px 60px;\r\n  z-index: 99999;\r\n  border: none;\r\n}\r\n\r\n.notification-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n  width: 725px;\r\n  box-shadow: -5px 0px 14px #0000000d;\r\n  border-radius: 34px 0px 0px 34px;\r\n  padding: 30px 0px 40px 72px;\r\n  z-index: 99999;\r\n  border: none;\r\n}\r\n\r\n.notification-offcanvas-wrapper .offcanvas-body {\r\n  padding: 0px;\r\n}\r\n\r\n.notification-drawer-main-wrap {\r\n  padding-right: 30px;\r\n}\r\n\r\n.chat-drawer-main-wrap {\r\n  padding-right: 0px;\r\n}\r\n\r\n.chat-drawer-main-wrap .notification-drawer-header {\r\n  padding-right: 46px;\r\n}\r\n\r\n.chat-drawer-main-wrap .chat-send-message-wrapper {\r\n  padding-right: 46px;\r\n}\r\n\r\n.cart-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n  width: 775px;\r\n  box-shadow: -5px 0px 14px #0000000d;\r\n  border-radius: 34px 0px 0px 34px;\r\n  padding: 20px 0px 120px 62px;\r\n  z-index: 99999;\r\n  border: none;\r\n}\r\n\r\n.chat-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n  width: 724px;\r\n  box-shadow: -5px 0px 14px #0000000d;\r\n  border-radius: 34px 0px 0px 34px;\r\n  padding: 20px 0px 0px 56px;\r\n  z-index: 99999;\r\n}\r\n\r\n.chat-offcanvas-wrapper .offcanvas-body {\r\n  padding: 0px;\r\n}\r\n\r\n.drawer-main-header-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 35px;\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n}\r\n\r\n.drawer-main-header-wrap h4 {\r\n  font-size: 24px;\r\n  color: #1a1919;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n}\r\n\r\n.drawer-main-header-wrap img {\r\n  cursor: pointer;\r\n}\r\n\r\n.drawer-close-icon img {\r\n  font-size: 38px;\r\n  cursor: pointer;\r\n}\r\n\r\n.history-list-drawer-table thead {\r\n  background-color: #00a19b08;\r\n}\r\n\r\n.history-list-drawer-table .table.table-hover thead th {\r\n  padding: 10px;\r\n  background-color: #00a19b08;\r\n}\r\n\r\n.history-list-drawer-table .table-hover > tbody > tr:hover > * {\r\n  --bs-table-color-state: unset !important;\r\n  --bs-table-bg-state: unset !important;\r\n}\r\n\r\n.history-list-drawer-table tbody,\r\ntd,\r\ntfoot,\r\nth,\r\nthead,\r\ntr {\r\n  border-color: inherit;\r\n  border-style: solid;\r\n  border-width: 0;\r\n  border: none;\r\n}\r\n\r\n.history-list-drawer-table thead th:first-child {\r\n  border-top-left-radius: 15px;\r\n  border-bottom-left-radius: 15px;\r\n}\r\n\r\n.history-list-drawer-table thead th:last-child {\r\n  border-top-right-radius: 15px;\r\n  border-bottom-right-radius: 15px;\r\n}\r\n\r\n.history-list-drawer-table .table.table-hover thead th {\r\n  color: #383838;\r\n  font-size: 20px;\r\n}\r\n\r\n.history-list-drawer-table .table tbody tr td {\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n}\r\n\r\n.history-list-drawer-table .table.table-hover thead th {\r\n  color: #383838;\r\n  font-size: 18px;\r\n  padding-left: 22px;\r\n}\r\n\r\n.history-list-drawer-table .table tbody tr:first-child td {\r\n  padding-top: 20px;\r\n}\r\n\r\n.history-list-drawer-table .table tbody tr td {\r\n  color: #717171;\r\n  font-size: 18px;\r\n  white-space: nowrap;\r\n  padding-left: 20px;\r\n  vertical-align: middle;\r\n}\r\n\r\n/* .history-list-drawer-table .table-responsive {\r\n    -webkit-overflow-scrolling: touch;\r\n    height: 85vh;\r\n    overflow-x: auto;\r\n    overflow-y: auto;\r\n  } */\r\n\r\n.history-item-images-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 22px;\r\n}\r\n\r\n.history-item-images-holder {\r\n  display: flex;\r\n  width: 55px;\r\n}\r\n\r\n.history-item-image-box {\r\n  width: 34px;\r\n  height: 34px;\r\n  background: #f3f3f3;\r\n  border-radius: 50%;\r\n  margin-left: -14px;\r\n  overflow: hidden;\r\n  object-fit: cover;\r\n  padding: 4px;\r\n}\r\n\r\n.history-item-images-holder img {\r\n  width: 100%;\r\n}\r\n\r\n.history-item-images-wrapper img.main-image {\r\n  width: 46px;\r\n}\r\n\r\n.items-hold-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0px;\r\n}\r\n\r\n.items-hold-wrap p {\r\n  width: 200px;\r\n  font-size: 18px;\r\n  color: #717171;\r\n  font-weight: 400;\r\n  margin: 0px;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n}\r\n\r\n.items-hold-wrap span {\r\n  font-size: 18px;\r\n  color: #00a19b;\r\n  font-weight: 400;\r\n  margin: 0px;\r\n}\r\n\r\n.notification-drawer-header h3 {\r\n  font-size: 24px;\r\n  color: #1a1919;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n}\r\n\r\n.notification-drawer-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  position: sticky;\r\n  top: 0;\r\n  background: #fff;\r\n  padding-top: 20px;\r\n}\r\n\r\n.notification-drawer-header img {\r\n  width: 38px;\r\n  cursor: pointer;\r\n}\r\n\r\n.notification-items-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0px;\r\n  margin-left: 14px;\r\n  width: 60px;\r\n}\r\n\r\n.notification-item-image {\r\n  width: 34px;\r\n  background: #f3f3f3;\r\n  border-radius: 50%;\r\n  margin-left: -14px;\r\n  padding: 2px;\r\n}\r\n\r\n.notification-item-image img {\r\n  width: 100%;\r\n}\r\n\r\n.notification-title-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.notification-title-wrap h4 {\r\n  font-size: 18px;\r\n  color: #1a1919;\r\n  font-weight: bold;\r\n  margin: 0px;\r\n}\r\n\r\n.notification-title-wrap img {\r\n  width: 24px;\r\n}\r\n\r\n.notification-left-wrap {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 10px;\r\n}\r\n\r\n.notification-booking-id-wrap p {\r\n  font-size: 16px;\r\n  color: #1a1919;\r\n  font-weight: 500;\r\n  margin: 0px;\r\n}\r\n\r\n.notification-booking-id-wrap p span{\r\n  /* color: #0000EE; */\r\n  color: #00a19b;\r\n  cursor: pointer;\r\n}\r\n\r\n.notification-booking-id-wrap p span:hover{\r\n  color: #008081;\r\n}\r\n\r\n.notification-item-date-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding-top: 2px;\r\n}\r\n\r\n.notification-item-date-wrap.border-line p:last-child {\r\n  border-left: 1px solid #ccc;\r\n  padding-left: 10px;\r\n}\r\n\r\n.notification-item-desc p {\r\n  width: 350px;\r\n  font-size: 14px;\r\n  color: #6d6d6d;\r\n  font-weight: 400;\r\n  margin: 0px;\r\n}\r\n\r\n.notification-item-date-wrap p {\r\n  font-size: 14px;\r\n  color: #6d6d6d;\r\n  font-weight: 400;\r\n  margin: 0px;\r\n}\r\n\r\n/* .notification-item-date-wrap p:last-child  {\r\n  border-left: 1px solid #ccc;\r\n  padding-left: 10px;\r\n} */\r\n\r\n.notification-item-date-wrap:has(> p:nth-child(2)):not(:has(> p:nth-child(3))) p:last-child {\r\n  border-left: 1px solid #ccc;\r\n  padding-left: 10px;\r\n}\r\n\r\n.notification-order-repeat {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  margin-top: 40px;\r\n}\r\n\r\n.notification-item-price h4 {\r\n  font-size: 16px;\r\n  color: #00a19b;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n}\r\n\r\n.notification-date-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding-top: 40px;\r\n}\r\n\r\n.notification-line-wrap {\r\n  width: 100%;\r\n  height: 1px;\r\n  background: #f3f3f3;\r\n}\r\n\r\n.notification-date-wrap p {\r\n  font-size: 14px;\r\n  color: #626262;\r\n  font-weight: 400;\r\n  margin: 0px;\r\n}\r\n\r\n/************** Chat Masseges Drawer ****/\r\n.replay-chat-box-wrapper {\r\n  position: relative;\r\n  /* margin-top: 20px; */\r\n  width: 100%;\r\n  height: calc(100vh - 140px);\r\n}\r\n\r\n/******** Chat Bot Msg *****/\r\n.msger-chat {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 0px;\r\n  height: calc(100vh - 230px);\r\n  margin-top: 10px;\r\n  padding-right: 46px;\r\n}\r\n\r\n.msger-chat::-webkit-scrollbar {\r\n  width: 5px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.msger-chat::-webkit-scrollbar-track {\r\n  background: #ddd;\r\n}\r\n\r\n.msger-chat::-webkit-scrollbar-thumb {\r\n  background: #00a19b;\r\n}\r\n\r\n.msg {\r\n  display: flex;\r\n  align-items: flex-end;\r\n}\r\n\r\n.msg:last-of-type {\r\n  margin: 0;\r\n}\r\n\r\n.msg-bubble {\r\n  max-width: 450px;\r\n  padding: 15px;\r\n  border-radius: 25px;\r\n  background: #bae9e9;\r\n}\r\n\r\n.msg-info {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.msg-info-name {\r\n  font-size: 14px;\r\n  color: #313131;\r\n  font-weight: 500;\r\n  margin-left: 20px;\r\n}\r\n\r\n.msg-info-time {\r\n  font-size: 0.85em;\r\n}\r\n\r\n.right-msg {\r\n  flex-direction: row-reverse;\r\n}\r\n\r\n.right-msg .msg-bubble {\r\n  background: #00a19b;\r\n  color: #fff;\r\n  border-radius: 25px;\r\n}\r\n\r\n.replay-chat-box-wrap .msg.left-msg .msg-text {\r\n  font-size: 16px;\r\n  color: #1a1919;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n}\r\n\r\n.replay-chat-box-wrap .msg .msg-text {\r\n  font-size: 16px;\r\n  color: #ffffff;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n}\r\n\r\n.chat-right-message-wrap .msg-info-time p {\r\n  font-size: 14px;\r\n  color: #b5b5b5;\r\n  font-weight: 400;\r\n  margin: 0px;\r\n  text-align: right;\r\n  padding-right: 10px;\r\n}\r\n\r\n.chat-left-message-wrap .msg-info-time p {\r\n  font-size: 14px;\r\n  color: #b5b5b5;\r\n  font-weight: 400;\r\n  margin: 0px;\r\n  padding-right: 10px;\r\n}\r\n\r\n.chat-right-message-wrap {\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.right-info-time {\r\n  text-align: right;\r\n}\r\n\r\n.left-info-time {\r\n  text-align: left;\r\n}\r\n\r\n.right-info-time p,\r\n.left-info-time p {\r\n  font-size: 14px;\r\n  color: #b5b5b5;\r\n  font-weight: 400;\r\n  padding-top: 4px;\r\n  margin-left: 20px;\r\n  margin-right: 20px;\r\n}\r\n\r\n.chat-send-message-wrapper {\r\n  position: absolute;\r\n  width: 100%;\r\n  bottom: 0px;\r\n}\r\n\r\n.chat-send-message-wrap {\r\n  position: relative;\r\n}\r\n\r\n.chat-send-message-wrap input {\r\n  width: 100%;\r\n  height: 82px;\r\n  border: 1px solid #dfdfdf;\r\n  border-radius: 42px;\r\n  outline: none;\r\n  padding: 30px;\r\n}\r\n\r\n.chat-send-button img {\r\n  width: 65px;\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n.cleaner-partner.right {\r\n  display: none;\r\n}\r\n\r\n.cleaner-partner.left {\r\n  font-size: 18px;\r\n  color: #1a1919;\r\n  font-weight: 400;\r\n  margin: 0px;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.empty-conversation-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  height: calc(100vh - 260px);\r\n}\r\n\r\n.empty-conversation-wrap h3 {\r\n  font-size: 25px;\r\n  color: #1a1919;\r\n  font-weight: bold;\r\n  margin: 0px;\r\n}\r\n\r\n.empty-conversation-wrap p {\r\n  font-size: 22px;\r\n  color: #1a1919;\r\n  font-weight: 400;\r\n  text-align: center;\r\n  width: 60%;\r\n  padding-top: 10px;\r\n}\r\n\r\n.empty-conversation-wrap img {\r\n  width: 150px;\r\n}\r\n\r\n/******* Extra Drawer Css ****/\r\n.extra-drawer-main-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 32px;\r\n  padding-right: 40px;\r\n}\r\n\r\n.extra-back-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.extra-drawer-main-header h4 {\r\n  font-size: 16px;\r\n  margin: 0px;\r\n  font-weight: 600;\r\n}\r\n\r\n.extra-drawer-size-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-top: 10px;\r\n}\r\n\r\n.extra-drawer-size {\r\n  width: 140px;\r\n  height: 40px;\r\n  border: 1px solid #f3f3f3;\r\n  border-radius: 9px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.extra-drawer-size p {\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  color: #a2a2a2;\r\n  margin: 0px;\r\n}\r\n\r\n.extra-drawer-price {\r\n  margin-top: 8px;\r\n}\r\n\r\n.extra-drawer-price p {\r\n  font-size: 12px;\r\n  text-align: center;\r\n  margin: 0px;\r\n  color: #626262;\r\n  font-weight: 400;\r\n}\r\n\r\n.extra-drawer-size-repeat.active .extra-drawer-size {\r\n  border: 1px solid #00a19b;\r\n}\r\n\r\n.extra-drawer-size-repeat.active .extra-drawer-size p {\r\n  font-weight: 500;\r\n  color: #00a19b;\r\n}\r\n\r\n.extra-drawer-size-repeat.active .extra-drawer-price p {\r\n  color: #00a19b;\r\n  font-weight: 500;\r\n}\r\n\r\n.extra-drawer-size-wrapper h4 {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n  color: #1a1919;\r\n}\r\n\r\n.extra-category-dropdown-wrap {\r\n  /* margin-top: 50px; */\r\n  margin-top: 38px;\r\n}\r\n\r\n.extra-drawer-main-wrapper {\r\n  position: relative;\r\n  min-height: calc(100vh - 110px);\r\n}\r\n\r\n/* .extra-addto-cart-btn{\r\n  width: 100%;\r\n  position: absolute;\r\n  bottom: 10px;\r\n} */\r\n\r\n.extra-addto-cart-btn {\r\n  width: 100%;\r\n  position: sticky;\r\n  bottom: 0px;\r\n  background: #fff;\r\n  z-index: 999999;\r\n  padding-right: 40px;\r\n  padding-bottom: 20px;\r\n  padding-top: 20px;\r\n}\r\n\r\n.extra-close-drwaer-btn img {\r\n  width: 30px;\r\n  cursor: pointer;\r\n}\r\n\r\n.extra-close-drwaer-btn:hover img {\r\n  transform: scale(0.9);\r\n}\r\n\r\n.addition-drawer-item-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.addition-drawer-item-wrap img {\r\n  width: 84px;\r\n  height: 90px;\r\n}\r\n\r\n.addition-drawer-item-wrap p {\r\n  font-size: 19px;\r\n  font-weight: 500;\r\n  margin: 0px;\r\n  color: #1a1919;\r\n}\r\n\r\n.additional-drawer-sqfeet-wrap p {\r\n  font-size: 14px;\r\n  color: #1a1919;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n/***** Coupon Drawer css *******/\r\n\r\n.apply-coupan-input {\r\n  position: relative;\r\n}\r\n\r\n.apply-coupan-btn {\r\n  position: absolute;\r\n  top: 14px;\r\n  right: 14px;\r\n  cursor: pointer;\r\n  z-index: 999;\r\n}\r\n\r\n.apply-coupan-btn.offer-apply-coupan-btn {\r\n  top: 16px;\r\n  right: 20px;\r\n}\r\n\r\n/* .offer-apply-coupan-btn{\r\n  position: unset;\r\n} */\r\n\r\n.apply-coupan-btn button {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  width: 86px;\r\n  background: #f3f3f3;\r\n  min-height: 36px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #00a19b;\r\n  cursor: pointer;\r\n  border: none;\r\n  border-radius: 9px;\r\n}\r\n\r\n.apply-coupan-btn button:hover{\r\n  background: #00a19b;\r\n  color: #f3f3f3;\r\n}\r\n\r\n.offer-apply-coupan-btn.disabled button:hover{\r\n  color: #bebebe;\r\n  background: #fff;\r\n}\r\n\r\n\r\n\r\nbutton.remove-coupon {\r\n  color: #ff0000;\r\n  padding: 0px 20px;\r\n}\r\n\r\n.offer-apply-coupan-btn button {\r\n  background: #fff;\r\n}\r\n\r\n.coupan-more-offers-wrap {\r\n  margin-top: 45px;\r\n}\r\n\r\n.coupan-more-offers-wrap h5 {\r\n  font-size: 16px;\r\n  margin: 0px;\r\n  font-weight: 500;\r\n}\r\n\r\n.more-offer-repeat {\r\n  margin-top: 20px;\r\n}\r\n\r\n.more-offer-card-wrap {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 148px;\r\n  background: #f3f3f3;\r\n  padding: 20px;\r\n  display: flex;\r\n  gap: 20px;\r\n  /* justify-content: space-between; */\r\n  border-radius: 26px;\r\n}\r\n\r\n.coupan-code-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0px;\r\n}\r\n\r\n.coupan-code-wrap img {\r\n  width: 40px;\r\n  margin-right: 5px;\r\n}\r\n\r\n.coupan-code-wrap h5 {\r\n  font-size: 14px;\r\n  margin: 0px;\r\n  font-weight: 500;\r\n  color: #1a1919;\r\n}\r\n\r\n.coupan-offer-desc-wrap {\r\n  margin-top: 10px;\r\n  margin-left: 4px;\r\n}\r\n\r\n.coupan-offer-desc-wrap h6 {\r\n  font-size: 12px;\r\n  margin: 0px;\r\n  font-weight: 400;\r\n  color: #1a1919;\r\n  width: 70%;\r\n}\r\n\r\n.coupan-offer-desc-wrap p {\r\n  font-size: 12px;\r\n  color: #878787;\r\n  margin: 0px;\r\n  font-weight: 400;\r\n  padding-top: 14px;\r\n}\r\n\r\n.coupan-subtract-wrap svg {\r\n  margin-top: -20px;\r\n  margin-left: -30px;\r\n}\r\n\r\n.coupan-subtract-wrap h3 {\r\n  font-size: 18px;\r\n  color: #ffffff;\r\n  font-weight: bold;\r\n  margin: 0px;\r\n  position: absolute;\r\n  top: 10px;\r\n  left: 0;\r\n}\r\n\r\n.discount-top-left {\r\n  font-size: 18px;\r\n  color: #ffffff;\r\n  font-weight: bold;\r\n  margin: 0px;\r\n  position: absolute;\r\n  top: 30px;\r\n  left: 6px;\r\n  transform: rotate(-90deg) scaleX(-1);\r\n  transform-origin: top left;\r\n\r\n  .content {\r\n    transform: scaleX(-1);\r\n  }\r\n}\r\n\r\n.coupan-subtract-wrap.disabled svg path {\r\n  fill: #bebebe;\r\n}\r\n\r\n.offer-apply-coupan-btn.disabled button {\r\n  color: #bebebe;\r\n  font-weight: 500;\r\n  cursor: default;\r\n}\r\n\r\n/********* Postpaid drawer css ******/\r\n\r\n.postpaid-drawer-main-header {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.postpaid-contant-wrap p {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  margin: 0px;\r\n  color: #1a1919;\r\n  width: 90%;\r\n}\r\n\r\n.postpaid-detail-repeat {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  border-bottom: 1px solid #c5c5c5;\r\n  height: 80px;\r\n  opacity: 0.4;\r\n}\r\n\r\n.postpaid-detail-repeat h3 {\r\n  font-size: 14px;\r\n  color: #1a1919;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n}\r\n\r\n.postpaid-main-wrap {\r\n  margin-top: 150px;\r\n}\r\n\r\n.postpaid-main-wrap p {\r\n  font-size: 14px;\r\n  color: #1a1919;\r\n  font-weight: 400;\r\n  margin: 0px;\r\n  padding-bottom: 40px;\r\n}\r\n\r\n.postpaid-detail-repeat.active {\r\n  opacity: 1;\r\n}\r\n\r\n.postpaid-submit-btn {\r\n  width: 100%;\r\n  position: absolute;\r\n  bottom: 0px;\r\n}\r\n\r\n.postpaid-submit-btn button {\r\n  height: 49px;\r\n}\r\n\r\n.postpaid-status-main-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  text-align: center;\r\n  height: calc(100vh - 200px);\r\n}\r\n\r\n\r\n.postpaid-status-image img{\r\n  width: 190px;\r\n}\r\n\r\n.postpaid-status-image img.postpaid-reject-image{\r\n  width: 125px;\r\n}\r\n\r\n.postpaid-status-image img.postpaid-approved-image{\r\n  width: 150px;\r\n}\r\n\r\n.postpaid-status-image{\r\n  padding-bottom: 25px;\r\n}\r\n\r\n.postpaid-status-content-wrap h3 {\r\n  font-size: 16px;\r\n  color: #1A1919;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n  padding-bottom: 25px;\r\n}\r\n\r\n.postpaid-status-content-wrap p {\r\n  font-size: 14px;\r\n  color: #1A1919;\r\n  font-weight: 400;\r\n  margin: 0px;\r\n  width: 380px;\r\n}\r\n\r\n\r\n/********** Cart Drawer css ********/\r\n.cart-drawer-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  position: sticky;\r\n  top: -16px;\r\n  background: #fff;\r\n}\r\n\r\n.cart-drawer-header h3 {\r\n  font-size: 24px;\r\n  color: #1a1919;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n}\r\n\r\n.cart-drawer-retail-wrap h4 {\r\n  font-size: 18px;\r\n  color: #1a1919;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n  margin-bottom: 22px;\r\n}\r\n\r\n.cart-square-feet-wrap p {\r\n  font-size: 16px;\r\n  color: #1a1919;\r\n  font-weight: 400;\r\n  margin: 0px;\r\n}\r\n\r\n.cart-square-feet-wrap span {\r\n  font-size: 18px;\r\n  color: #1a1919;\r\n  font-weight: 400;\r\n  margin: 0px;\r\n}\r\n\r\n.cart-drawer-retail-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 28px;\r\n  margin-top: 70px;\r\n}\r\n\r\n.cart-square-image img {\r\n  width: 110px;\r\n}\r\n\r\n.cart-total-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.cart-total-wrap h3 {\r\n  font-size: 20px;\r\n  color: #1a1919;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n}\r\n\r\n.cart-total-wrap h4 {\r\n  font-size: 20px;\r\n  color: #00a19b;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n}\r\n\r\n.cart-booking-wrapper {\r\n  width: 650px;\r\n  position: fixed;\r\n  bottom: 40px;\r\n  background: #ffff;\r\n}\r\n\r\n.cart-drawer-main-wrapper .booking-cart-items-wrap h5 {\r\n  font-size: 18px;\r\n}\r\n\r\n.cart-drawer-main-wrapper .booking-item-detail h6 {\r\n  font-size: 18px;\r\n}\r\n\r\n.cart-drawer-main-wrapper .booking-item-detail p {\r\n  font-size: 18px;\r\n}\r\n\r\n.cart-drawer-main-wrapper .booking-item-detail span {\r\n  font-size: 18px;\r\n}\r\n\r\n.cart-drawer-main-wrapper .booking-item-image {\r\n  width: 28px;\r\n  height: 28px;\r\n}\r\n\r\n.cart-drawer-main-wrapper .update-quantity-btn {\r\n  min-width: 110px;\r\n  padding: 5px 10px;\r\n  border-radius: 17px;\r\n}\r\n\r\n.cart-drawer-main-wrapper .update-quantity-btn span {\r\n  text-align: center;\r\n  font-size: 16px;\r\n  width: 20px;\r\n}\r\n\r\n.cart-drawer-main-wrapper span.percentage-text {\r\n  width: 40px;\r\n  text-align: center;\r\n}\r\n\r\n.cart-drawer-main-wrapper .update-quantity-btn h4 {\r\n  font-size: 22px;\r\n  width: 16px;\r\n  text-align: center;\r\n}\r\n\r\n.cart-drawer-main-wrapper .booking-item-price-wrap p {\r\n  font-size: 18px;\r\n  min-width: 80px;\r\n}\r\n\r\n.cart-drawer-main-wrapper .booking-cart-item-right {\r\n  gap: 26px;\r\n}\r\n\r\n.cart-drawer-main-wrapper .edit-extra-item-btn {\r\n  min-width: 105px;\r\n  padding: 5px;\r\n  border-radius: 17px;\r\n}\r\n\r\n.drawer-close-icon-wrap img {\r\n  width: 38px;\r\n  cursor: pointer;\r\n}\r\n\r\n.history-centered-icon {\r\n  text-align: center;\r\n}\r\n\r\n.cart-drawer-main-wrap .booking-item-price-wrap {\r\n  display: none;\r\n}\r\n\r\n.drawer-close-icon-wrap:hover img {\r\n  transform: scale(0.9);\r\n}\r\n\r\n.drawer-close-icon:hover img {\r\n  transform: scale(0.9);\r\n}\r\n\r\n.close-icon-wrap:hover img {\r\n  transform: scale(0.9);\r\n}\r\n\r\n.login-option.addtional-drawer-squirefeet-input .field label::before {\r\n  left: 15px !important;\r\n}\r\n\r\n.flooring-dropdown-toggle-wrapper {\r\n  margin-top: 23px;\r\n}\r\n\r\n.flooring-dropdown-toggle-wrapper h3 {\r\n  font-size: 14px;\r\n  color: #1a1919;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n}\r\n\r\n.flooring-dropdown-toggle {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  margin-top: 18px;\r\n}\r\n\r\n.flooring-toggle-left {\r\n  width: 140px;\r\n  height: 40px;\r\n  border: 1px solid #f3f3f3;\r\n  border-radius: 9px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.flooring-toggle-left p {\r\n  font-size: 14px;\r\n  color: #a2a2a2;\r\n  font-weight: 400;\r\n  margin: 0px;\r\n}\r\n\r\n.flooring-toggle-left.active {\r\n  border: 1px solid #00a19b;\r\n}\r\n\r\n.flooring-toggle-left.active p {\r\n  color: #00a19b;\r\n}\r\n\r\n.chat-date-divider {\r\n  width: 80%;\r\n  border: 1px solid #e9e9e9;\r\n  height: 0px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 0 auto;\r\n  margin-top: 26px;\r\n  margin-bottom: 34px;\r\n}\r\n\r\n.chat-date-divider span {\r\n  display: block;\r\n  background: #fff;\r\n  padding: 0px 20px;\r\n  color: #b5b5b5;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n}\r\n\r\n.noting-found-main-wrap img {\r\n  width: 112px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.noting-found-main-wrap p {\r\n  font-size: 24px;\r\n  color: #b2b2b2;\r\n  margin: 0px;\r\n  font-weight: 400;\r\n}\r\n\r\n.noting-found-main-wrap {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: calc(100vh - 200px);\r\n}\r\n\r\n.nothing-found-cart-wrap {\r\n  height: calc(100vh - 210px);\r\n}\r\n\r\n.history-centered-icon.history-status-image img {\r\n  width: 30px;\r\n  margin-left: -20px;\r\n}\r\n\r\ninput.error-msg.placeholder-error-text::placeholder {\r\n  color: #ff0000;\r\n}\r\n\r\nimg.disable-button {\r\n  opacity: 0.5;\r\n  cursor: no-drop;\r\n}\r\n\r\n.notification-item-staticImg {\r\n  width: 55px;\r\n  margin-left: -14px !important;\r\n}\r\n\r\n.notification-item-staticImg img {\r\n  width: 100%;\r\n}\r\n\r\n.addcard-main-wrapper {\r\n  width: 100%;\r\n  margin: 0 auto;\r\n  padding: 40px 20px;\r\n  /* background-color: #f9f9f9; */\r\n  border-radius: 20px;\r\n  border: 2px solid #f8f8f8;\r\n  margin-top: 50px;\r\n}\r\n\r\n.addcard-main-wrapper form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n.addcard-main-wrapper .form-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n}\r\n\r\n.addcard-main-wrapper .form-group label {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #1a1919;\r\n  font-family: \"Montserrat\";\r\n  margin-left: 10px;\r\n}\r\n\r\n.custom-stripe-input {\r\n  border: 1px solid #f3f3f3;\r\n  border-radius: 9px;\r\n  padding: 20px 10px;\r\n  font-weight: 500;\r\n  background-color: #fff;\r\n}\r\n\r\n.save-card-btn button {\r\n  height: 49px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.contractor-certificate-wrapper {\r\n  margin-top: 50px;\r\n}\r\n\r\np.postpaid-info-content {\r\n  font-size: 14px;\r\n  color: #1a1919;\r\n  font-weight: 400;\r\n  margin: 0px;\r\n  padding-bottom: 20px;\r\n}\r\n\r\np.uploaded-pdf {\r\n  color: #0d6efd !important;\r\n  font-style: italic;\r\n}\r\n\r\n.contractor-certificate-wrap {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 22px;\r\n}\r\n\r\n.certificate-upload-box {\r\n  border: 1px solid #f3f3f3;\r\n  border-radius: 9px;\r\n  height: 62px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 0px 20px;\r\n  position: relative;\r\n}\r\n\r\n.certificate-upload-box input {\r\n  width: 40px;\r\n  opacity: 0;\r\n  position: absolute;\r\n  cursor: pointer;\r\n}\r\n\r\n.certificate-upload-box p {\r\n  font-size: 14px;\r\n  color: #1a1919;\r\n  font-weight: 400;\r\n  white-space: nowrap;\r\n  margin: 0px;\r\n  width: 200px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\np.check-path-text {\r\n  font-style: italic;\r\n  color: #0f0fd5;\r\n}\r\n\r\n.upload-lable.active {\r\n  background: #fff;\r\n  position: absolute;\r\n  top: -10px;\r\n  width: auto;\r\n  left: 15px;\r\n  padding: 0px 5px;\r\n}\r\n\r\n.upload-icon-wrap img {\r\n  width: 24px;\r\n  cursor: pointer;\r\n}\r\n\r\n.contractor-certificate-wrap {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 22px;\r\n}\r\n\r\nspan.postpaid-status-Rejected {\r\n  margin-left: 10px;\r\n  color: #ff0000;\r\n}\r\n\r\nspan.postpaid-status-Pending {\r\n  margin-left: 10px;\r\n}\r\n\r\nh3.multi-addition-main-title {\r\n  font-size: 16px;\r\n  margin-top: 20px;\r\n  font-weight: 600;\r\n  margin-left: 10px;\r\n  color: #00a19b;\r\n}\r\n\r\n.additional-add-item-btn {\r\n  text-align: right;\r\n  margin-top: 20px;\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: right;\r\n}\r\n\r\n.additional-add-item-btn button {\r\n  background: #00a19b;\r\n  width: 100px;\r\n  color: #fff;\r\n}\r\n\r\n.selected-items-list {\r\n  margin-top: 30px;\r\n}\r\n\r\n.selected-items-list h3 {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n}\r\n\r\n.selected-items-list .selected-item {\r\n  font-size: 14px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.selected-items-list span.delete-item-icon {\r\n  margin: 0px;\r\n  width: 19px;\r\n  height: 19px;\r\n  border-radius: 50%;\r\n  background: #d3e9e9;\r\n  color: #00a19b;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0px;\r\n}\r\n\r\n.selected-items-list span.delete-item-icon {\r\n  margin-top: 2px;\r\n}\r\n\r\np.error-msg.postpaid-error-msg{\r\n  margin-top: 10px;\r\n}\r\n\r\n.additional-sqfeet-wrap{\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n\r\n.additional-sqfeet-wrap img{\r\n  cursor: pointer;\r\n}\r\n\r\n.additional-sqfeet-wrap p{\r\n  margin: 0px;\r\n}\r\n\r\n\r\n.booking-view-icon{\r\n  text-align: right;\r\n  margin-top: 10px;\r\n}\r\n\r\n.booking-view-icon img{\r\n  width: 30px;\r\n  cursor: pointer;\r\n}\r\n\r\n.booking-view-icon img:hover{\r\n  scale: 0.9;\r\n}\r\n\r\nimg.table-view-icon:hover{\r\n  scale: 0.9;\r\n}\r\n\r\n/******* Resposive css ****/\r\n@media (max-width: 1024px) {\r\n  .history-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n    width: 100%;\r\n    box-shadow: -5px 0px 14px #0000000d;\r\n    border-radius: 0px;\r\n    padding: 30px 0px 30px 0px;\r\n    z-index: 99999;\r\n  }\r\n\r\n  .drawer-main-header-wrap h4 {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .items-hold-wrap p {\r\n    width: 80px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .items-hold-wrap span {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .history-list-drawer-table .table tbody tr td {\r\n    color: #717171;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .table-view-icon-wrap {\r\n    text-align: center;\r\n    margin-left: -20px;\r\n  }\r\n\r\n  .table-view-icon-wrap img {\r\n    width: 35px;\r\n  }\r\n\r\n  .history-list-drawer-table .table tbody tr:first-child td {\r\n    padding-top: 12px;\r\n  }\r\n\r\n  .history-list-drawer-table .table.table-hover thead th {\r\n    color: #383838;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    padding-top: 12px;\r\n    padding-bottom: 12px;\r\n  }\r\n\r\n  .history-list-drawer-table thead th:first-child {\r\n    border-top-left-radius: 0px;\r\n    border-bottom-left-radius: 0px;\r\n  }\r\n\r\n  .history-list-drawer-table thead th:last-child {\r\n    border-top-right-radius: 0px;\r\n    border-bottom-right-radius: 0px;\r\n  }\r\n\r\n  .history-offcanvas-wrapper .offcanvas-body {\r\n    padding: 0px !important;\r\n  }\r\n\r\n  .extras-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n    width: 100%;\r\n    padding: 30px 0px 0px 20px;\r\n  }\r\n\r\n  .postpaid-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n    padding: 30px 30px 0px 30px;\r\n  }\r\n\r\n  .extras-offcanvas-wrapper .offcanvas-body {\r\n    padding-bottom: 0px;\r\n  }\r\n\r\n  .addition-drawer-main-wrap {\r\n    padding-right: 30px;\r\n  }\r\n\r\n  .extra-drawer-main-header {\r\n    padding-right: 30px;\r\n  }\r\n\r\n  .extra-addto-cart-btn {\r\n    padding-right: 30px;\r\n  }\r\n\r\n  .extra-drawer-main-wrapper {\r\n    /* padding-right: 20px; */\r\n    /* min-height: calc(100vh - 160px); */\r\n  }\r\n\r\n  .extra-drawer-size-wrap {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    align-items: flex-start;\r\n    margin-top: 10px;\r\n  }\r\n  .extra-drawer-size-repeat {\r\n    display: flex;\r\n    gap: 10px;\r\n  }\r\n\r\n  .extra-drawer-main-header h4 {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .extra-back-wrap img {\r\n    width: 8px;\r\n  }\r\n\r\n  .extra-category-dropdown-wrap {\r\n    margin-top: 40px;\r\n  }\r\n\r\n  /* .extra-addto-cart-btn {\r\n  padding-right: 20px;\r\n  bottom: 0px;\r\n} */\r\n\r\n  button.add-to-cart-btn {\r\n    height: 62px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .extra-back-wrap img {\r\n    display: none;\r\n  }\r\n\r\n  .postpaid-contant-wrap p {\r\n    font-size: 14px;\r\n    width: 100%;\r\n  }\r\n\r\n  .postpaid-main-wrap {\r\n    margin-top: 50px;\r\n  }\r\n\r\n  .postpaid-main-wrap p {\r\n    padding-bottom: 10px;\r\n  }\r\n\r\n  .postpaid-detail-repeat {\r\n    height: 70px;\r\n  }\r\n\r\n  .postpaid-submit-btn {\r\n    padding-right: 20px;\r\n  }\r\n\r\n  .postpaid-submit-btn button {\r\n    height: 62px;\r\n  }\r\n\r\n  .coupon-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n    width: 100%;\r\n    padding: 20px 0px 30px 26px;\r\n  }\r\n\r\n  .coupon-offcanvas-wrapper .extra-drawer-main-wrapper {\r\n    padding-right: 14px;\r\n  }\r\n\r\n  .coupan-more-offers-wrap h5 {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .coupan-offer-desc-wrap {\r\n    width: 100%;\r\n  }\r\n\r\n  .more-offer-card-wrap {\r\n    border-radius: 14px;\r\n    gap: 14px;\r\n  }\r\n\r\n  .chat-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n    width: 100%;\r\n    border-radius: 0px;\r\n    padding: 20px 0px 10px 26px;\r\n  }\r\n\r\n  .chat-offcanvas-wrapper .offcanvas-body {\r\n    padding-right: 0px;\r\n  }\r\n\r\n  .chat-offcanvas-wrapper .notification-drawer-header {\r\n    padding-right: 26px;\r\n    padding-bottom: 0px;\r\n  }\r\n\r\n  .notification-drawer-header {\r\n    padding-bottom: 20px;\r\n  }\r\n\r\n  .notification-drawer-header h3 {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .empty-conversation-wrap h3 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .empty-conversation-wrap p {\r\n    font-size: 14px;\r\n    width: 88%;\r\n  }\r\n\r\n  .msger-chat {\r\n    padding: 0px;\r\n    padding-right: 26px;\r\n    height: calc(100vh - 240px);\r\n  }\r\n\r\n  .chat-drawer-main-wrap .chat-send-message-wrapper {\r\n    padding-right: 26px;\r\n  }\r\n\r\n  .chat-send-message-wrap input {\r\n    width: 100%;\r\n    height: 72px;\r\n  }\r\n\r\n  .chat-send-button img {\r\n    width: 52px;\r\n  }\r\n\r\n  .cleaner-partner.left {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .msg-bubble {\r\n    max-width: 450px;\r\n    padding: 12px 25px;\r\n  }\r\n\r\n  .right-info-time p,\r\n  .left-info-time p {\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    padding-top: 4px;\r\n    margin-left: 18px;\r\n    margin-right: 18px;\r\n  }\r\n\r\n  .replay-chat-box-wrapper {\r\n    height: calc(100vh - 170px);\r\n  }\r\n\r\n  .chat-send-message-wrapper {\r\n    padding-right: 24px;\r\n  }\r\n\r\n  .write-review-wrapper textarea {\r\n    border: 1px solid #f3f3f3;\r\n    border-radius: 13px;\r\n    width: 100%;\r\n  }\r\n\r\n  .trackorder-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n    /* width: 725px; */\r\n    width: 600px;\r\n    box-shadow: -5px 0px 14px #0000000d;\r\n    border-radius: 0px;\r\n    padding: 40px 10px 10px 20px;\r\n    z-index: 9999;\r\n  }\r\n\r\n  .trackorder-offcanvas-wrapper .book-button-wrapper {\r\n    margin-top: 14px;\r\n  }\r\n\r\n  .trackorder-offcanvas-wrapper .order-track-text {\r\n    width: 100%;\r\n  }\r\n\r\n  .write-review-wrapper textarea {\r\n    width: 100% !important;\r\n  }\r\n\r\n  .track-close-icon-wrap {\r\n    position: absolute;\r\n    right: 30px;\r\n  }\r\n\r\n  .track-close-icon-wrap img {\r\n    width: 38px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .order-track-status-line {\r\n    height: 100px;\r\n  }\r\n\r\n  .order-cance-btn {\r\n    width: 100%;\r\n  }\r\n\r\n  .cancel-order-main-wrap {\r\n    bottom: 30px !important;\r\n    padding-left: 30px;\r\n    padding-right: 20px;\r\n  }\r\n\r\n  button.cancel-order-button {\r\n    width: 100%;\r\n  }\r\n\r\n  .cancel-order-info {\r\n    align-items: baseline !important;\r\n  }\r\n\r\n  .noting-found-main-wrap img {\r\n    width: 90px;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .noting-found-main-wrap p {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .postpaid-status-content-wrap p {\r\n    width: unset;\r\n  }\r\n}\r\n\r\n@media (max-width: 360px) {\r\n  .coupon-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n    width: 100%;\r\n    padding: 20px 0px 30px 22px;\r\n  }\r\n\r\n  .coupon-offcanvas-wrapper .extra-drawer-main-wrapper {\r\n    padding-right: 12px;\r\n  }\r\n\r\n  .more-offer-card-wrap {\r\n    gap: 10px;\r\n  }\r\n\r\n  .apply-coupan-btn.offer-apply-coupan-btn {\r\n    right: 14px;\r\n  }\r\n\r\n  .postpaid-main-wrap {\r\n    margin-top: 40px;\r\n  }\r\n\r\n  .coupan-code-wrap img {\r\n    width: 24px;\r\n    margin-right: 2px;\r\n  }\r\n\r\n  .postpaid-detail-repeat {\r\n    height: 60px;\r\n  }\r\n}\r\n\r\n@media (max-width: 330px) {\r\n  .coupon-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n    width: 100%;\r\n    padding: 20px 0px 20px 10px;\r\n  }\r\n\r\n  .coupon-offcanvas-wrapper .extra-drawer-main-wrapper {\r\n    padding-right: 0px;\r\n  }\r\n\r\n  .more-offer-card-wrap {\r\n    gap: 6px;\r\n  }\r\n\r\n  .apply-coupan-btn.offer-apply-coupan-btn {\r\n    right: 14px;\r\n  }\r\n\r\n  .coupan-code-wrap img {\r\n    width: 24px;\r\n    margin-right: 2px;\r\n  }\r\n\r\n  .extra-drawer-main-header h4 {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .postpaid-detail-repeat {\r\n    height: 56px;\r\n  }\r\n}\r\n/* \r\n@media (min-width: 768px) and (max-width: 1024px) {\r\n  .history-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n    width: 710px;\r\n    padding: 20px 0px 30px 30px;\r\n  }\r\n\r\n  .history-item-images-wrapper img.main-image {\r\n    display: none;\r\n  }\r\n\r\n  .history-item-image-box {\r\n    width: 30px;\r\n    border-radius: 50%;\r\n    margin-left: -12px;\r\n  }\r\n\r\n  .items-hold-wrap span {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .history-list-drawer-table .table tbody tr td {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .history-list-drawer-table .table.table-hover thead th {\r\n    font-size: 16px;\r\n    padding-left: 20px;\r\n  }\r\n\r\n.history-centered-icon img {\r\n  width: 30px;\r\n  margin-left: -10px;\r\n}\r\n\r\n.drawer-main-header-wrap h4 {\r\n  font-size: 22px;\r\n}\r\n\r\n.drawer-close-icon img {\r\n  width: 34px;\r\n}\r\n\r\n.drawer-main-header-wrap {\r\n  margin-bottom: 28px;\r\n  padding-left: 18px;\r\n  padding-right: 20px;\r\n}\r\n\r\n.items-hold-wrap p {\r\n  width: 60px;\r\n}\r\n\r\n\r\n.coupon-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n  width: 500px;\r\n}\r\n\r\n.extras-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n  width: 520px;\r\n  padding: 30px 30px 30px 30px;\r\n}\r\n\r\n.extra-drawer-size {\r\n  width: 130px;\r\n}\r\n\r\n.postpaid-main-wrap {\r\n  margin-top: 50px;\r\n}\r\n\r\n.postpaid-detail-repeat {\r\n  height: 70px;\r\n}\r\n\r\n.postpaid-main-wrap p {\r\n  padding-bottom: 20px;\r\n}\r\n\r\n.cart-total-wrap {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.cart-total-wrap h3 {\r\n  font-size: 18px;\r\n}\r\n\r\n.cart-total-wrap h4 {\r\n  font-size: 18px;\r\n}\r\n\r\n\r\n.cart-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n  width: 650px;\r\n  padding: 20px 20px 180px 30px;\r\n}\r\n\r\n.cart-booking-wrapper {\r\n  width: 550px;\r\n}\r\n\r\n.cart-drawer-main-wrap .booking-cart-item-repeat{\r\n  flex-direction: row;\r\n}\r\n\r\n.cart-drawer-main-wrapper h6.flooring-cat {\r\n  display: block;\r\n}\r\n\r\n\r\n.cart-drawer-retail-wrap h4 {\r\n  font-size: 16px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.cart-square-image img {\r\n  width: 80px;\r\n}\r\n\r\n.cart-drawer-main-wrapper .booking-item-detail h6 {\r\n  font-size: 16px;\r\n}\r\n\r\n.cart-drawer-main-wrapper .booking-item-detail p {\r\n  font-size: 16px;\r\n}\r\n\r\n.cart-drawer-main-wrapper .booking-item-detail span {\r\n  font-size: 16px;\r\n}\r\n\r\n.cart-drawer-main-wrapper .booking-cart-item-right {\r\n  gap: 10px;\r\n}\r\n\r\n.cart-drawer-main-wrapper .update-quantity-btn span {\r\n  font-size: 14px;\r\n}\r\n\r\n.cart-drawer-main-wrapper .booking-item-price-wrap p {\r\n  font-size: 16px;\r\n  min-width: 70px;\r\n}\r\n\r\n.cart-drawer-retail-wrap {\r\n  margin-top: 30px;\r\n}\r\n\r\n.notification-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n  width: 640px;\r\n  padding: 30px 20px 30px 30px\r\n}\r\n\r\n.notification-drawer-header h3 {\r\n  font-size: 22px;\r\n}\r\n\r\n.drawer-close-icon-wrap img {\r\n  width: 34px;\r\n}\r\n\r\n.notification-drawer-header {\r\n    padding-bottom: 20px;\r\n}\r\n\r\n.notification-title-wrap h4 {\r\n  font-size: 16px;\r\n}\r\n\r\n.notification-item-image {\r\n  width: 32px;\r\n}\r\n\r\n.notification-order-repeat {\r\n  margin-top: 40px;\r\n}\r\n\r\n.chat-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n  width: 560px;\r\n}\r\n\r\n.cleaner-partner.left {\r\n  font-size: 14px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.replay-chat-box-wrap .msg.left-msg .msg-text {\r\n  font-size: 14px;\r\n}\r\n\r\n.replay-chat-box-wrap .msg .msg-text {\r\n  font-size: 14px;\r\n}\r\n\r\n.msg-bubble {\r\n  padding: 10px 16px;\r\n}\r\n\r\n.right-info-time p, .left-info-time p {\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n    padding-top: 2px;\r\n    margin-left: 15px;\r\n    margin-right: 15px;\r\n}\r\n\r\n.chat-send-message-wrap input {\r\n  height: 68px;\r\n}\r\n\r\n.chat-send-button img {\r\n  width: 54px;\r\n  top: 8px;\r\n}\r\n\r\n.trackorder-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n  width: 500px;\r\n  box-shadow: -5px 0px 14px #0000000D;\r\n  border-radius: 34px 0px 0px 34px;\r\n  padding: 20px 0px 40px 40px;\r\n  z-index: 99999;\r\n}\r\n\r\n.cancel-order-main-wrap {\r\n  left: 40px;\r\n  right: 30px;\r\n  bottom: 40px;\r\n}\r\n\r\n.track-close-icon-wrap {\r\n  position: absolute;\r\n  right: 30px;\r\n}\r\n\r\n.track-close-icon-wrap img{\r\n  width: 34px;\r\n  cursor: pointer;\r\n}\r\n\r\n.fade.modal.show {\r\n  z-index: 999999;\r\n}\r\n\r\n} */\r\n\r\n@media (min-width: 1025px) and (max-width: 1199px) {\r\n  .history-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n    width: 680px;\r\n    padding: 20px 0px 30px 30px;\r\n  }\r\n\r\n  .history-item-images-wrapper img.main-image {\r\n    display: none;\r\n  }\r\n\r\n  .history-item-image-box {\r\n    width: 30px;\r\n    border-radius: 50%;\r\n    margin-left: -12px;\r\n  }\r\n\r\n  .items-hold-wrap span {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .history-list-drawer-table .table tbody tr td {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .history-list-drawer-table .table.table-hover thead th {\r\n    font-size: 16px;\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .history-centered-icon img {\r\n    width: 30px;\r\n    margin-left: -10px;\r\n  }\r\n\r\n  .drawer-main-header-wrap h4 {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .drawer-close-icon img {\r\n    width: 34px;\r\n  }\r\n\r\n  .drawer-main-header-wrap {\r\n    margin-bottom: 28px;\r\n    padding-left: 18px;\r\n    padding-right: 20px;\r\n  }\r\n\r\n  .items-hold-wrap p {\r\n    width: 60px;\r\n  }\r\n\r\n  .coupon-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n    width: 500px;\r\n  }\r\n\r\n  .extras-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n    width: 520px;\r\n    padding: 30px 0px 0px 30px;\r\n  }\r\n\r\n  .postpaid-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n    padding: 30px 30px 0px 30px;\r\n  }\r\n\r\n  .extras-offcanvas-wrapper .offcanvas-body {\r\n    padding-bottom: 0px;\r\n    /* padding-right: 30px; */\r\n  }\r\n\r\n  .addition-drawer-main-wrap {\r\n    padding-right: 30px;\r\n  }\r\n\r\n  .extra-drawer-main-header {\r\n    padding-right: 30px;\r\n  }\r\n\r\n  .extra-addto-cart-btn {\r\n    padding-right: 30px;\r\n  }\r\n\r\n  .extra-drawer-size {\r\n    width: 130px;\r\n  }\r\n\r\n  .postpaid-main-wrap {\r\n    margin-top: 50px;\r\n  }\r\n\r\n  .postpaid-detail-repeat {\r\n    height: 70px;\r\n  }\r\n\r\n  .postpaid-main-wrap p {\r\n    padding-bottom: 20px;\r\n  }\r\n\r\n  .cart-drawer-main-wrapper .booking-item-image {\r\n    width: 26px;\r\n    height: 26px;\r\n  }\r\n\r\n  .booking-cart-item-left {\r\n    gap: 8px;\r\n  }\r\n\r\n  .cart-total-wrap {\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .cart-total-wrap h3 {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .cart-total-wrap h4 {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .cart-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n    width: 620px;\r\n    padding: 20px 0px 110px 50px;\r\n  }\r\n\r\n  .cart-offcanvas-wrapper .cart-drawer-main-wrap {\r\n    padding-right: 30px;\r\n  }\r\n\r\n  .cart-offcanvas-wrapper.offcanvas-body {\r\n    padding: 0px;\r\n  }\r\n\r\n  .cart-offcanvas-wrapper .cart-button-wrap {\r\n    padding-right: 30px;\r\n  }\r\n\r\n  .cart-drawer-header {\r\n    background: #fff;\r\n    padding-bottom: 10px;\r\n  }\r\n\r\n  .cart-booking-wrapper {\r\n    width: 540px;\r\n  }\r\n\r\n  .cart-drawer-main-wrap .booking-cart-item-repeat {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .cart-drawer-main-wrapper h6.flooring-cat {\r\n    display: block;\r\n  }\r\n\r\n  .cart-drawer-retail-wrap h4 {\r\n    font-size: 16px;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .cart-square-image img {\r\n    width: 80px;\r\n  }\r\n\r\n  .cart-drawer-main-wrapper .booking-item-detail h6 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .cart-drawer-main-wrapper .booking-item-detail p {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .cart-drawer-main-wrapper .booking-item-detail span {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .cart-drawer-main-wrapper .booking-cart-item-right {\r\n    gap: 10px;\r\n  }\r\n\r\n  .cart-drawer-main-wrapper .update-quantity-btn span {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .cart-drawer-main-wrapper .booking-item-price-wrap p {\r\n    font-size: 16px;\r\n    min-width: 70px;\r\n  }\r\n\r\n  .cart-drawer-retail-wrap {\r\n    margin-top: 30px;\r\n  }\r\n\r\n  .notification-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n    width: 560px;\r\n    padding: 30px 0px 30px 60px;\r\n  }\r\n\r\n  .notification-drawer-header h3 {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .drawer-close-icon-wrap img {\r\n    width: 34px;\r\n  }\r\n\r\n  .notification-drawer-header {\r\n    padding-bottom: 10px;\r\n    padding-top: 10px;\r\n  }\r\n\r\n  .notification-title-wrap h4 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .notification-item-image {\r\n    width: 32px;\r\n  }\r\n\r\n  .notification-order-repeat {\r\n    margin-top: 30px;\r\n  }\r\n\r\n  .notification-date-wrap {\r\n    padding-top: 30px;\r\n  }\r\n\r\n  .chat-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n    width: 560px;\r\n  }\r\n\r\n  .cleaner-partner.left {\r\n    font-size: 14px;\r\n    margin-left: 10px;\r\n  }\r\n\r\n  .replay-chat-box-wrap .msg.left-msg .msg-text {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .replay-chat-box-wrap .msg .msg-text {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .msg-bubble {\r\n    padding: 10px 16px;\r\n  }\r\n\r\n  .right-info-time p,\r\n  .left-info-time p {\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n    padding-top: 2px;\r\n    margin-left: 15px;\r\n    margin-right: 15px;\r\n  }\r\n\r\n  .chat-send-message-wrap input {\r\n    height: 68px;\r\n  }\r\n\r\n  .chat-send-button img {\r\n    width: 54px;\r\n    top: 8px;\r\n  }\r\n\r\n  .replay-chat-box-wrapper {\r\n    height: calc(100vh - 120px);\r\n  }\r\n\r\n  .noting-found-main-wrap img {\r\n    width: 90px;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .noting-found-main-wrap p {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .apply-coupan-btn {\r\n    top: 6px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) and (max-width: 1599px) {\r\n  .items-hold-wrap p {\r\n    width: 60px;\r\n  }\r\n\r\n  .history-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n    width: 52%;\r\n    padding: 20px 0px 30px 30px;\r\n  }\r\n\r\n  .history-item-images-wrapper img.main-image {\r\n    display: none;\r\n  }\r\n\r\n  .history-item-image-box {\r\n    width: 30px;\r\n    border-radius: 50%;\r\n    margin-left: -12px;\r\n  }\r\n\r\n  .items-hold-wrap span {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .history-list-drawer-table .table tbody tr td {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .history-list-drawer-table .table.table-hover thead th {\r\n    font-size: 16px;\r\n    padding-left: 25px;\r\n  }\r\n\r\n  .history-centered-icon img {\r\n    width: 30px;\r\n  }\r\n\r\n  .drawer-main-header-wrap h4 {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .drawer-close-icon img {\r\n    width: 34px;\r\n  }\r\n\r\n  .drawer-main-header-wrap {\r\n    margin-bottom: 28px;\r\n    padding-left: 18px;\r\n    padding-right: 20px;\r\n  }\r\n\r\n  .coupon-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n    width: 500px;\r\n  }\r\n\r\n  .extras-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n    width: 520px;\r\n    padding: 30px 0px 0px 30px;\r\n  }\r\n\r\n  .postpaid-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n    padding: 30px 40px 0px 40px;\r\n  }\r\n\r\n  .extras-offcanvas-wrapper .offcanvas-body {\r\n    padding-bottom: 0px;\r\n    /* padding-right: 30px; */\r\n  }\r\n\r\n  .addition-drawer-main-wrap {\r\n    padding-right: 30px;\r\n  }\r\n\r\n  .extra-drawer-main-header {\r\n    padding-right: 30px;\r\n  }\r\n\r\n  .extra-addto-cart-btn {\r\n    padding-right: 30px;\r\n  }\r\n\r\n  .extra-drawer-size {\r\n    width: 130px;\r\n  }\r\n\r\n  .postpaid-main-wrap {\r\n    margin-top: 50px;\r\n  }\r\n\r\n  .postpaid-detail-repeat {\r\n    height: 70px;\r\n  }\r\n\r\n  .postpaid-main-wrap p {\r\n    padding-bottom: 20px;\r\n  }\r\n\r\n  .cart-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n    width: 620px;\r\n    padding: 20px 0px 110px 50px;\r\n  }\r\n\r\n  .cart-offcanvas-wrapper .cart-drawer-main-wrap {\r\n    padding-right: 30px;\r\n  }\r\n\r\n  .cart-offcanvas-wrapper.offcanvas-body {\r\n    padding: 0px;\r\n  }\r\n\r\n  .cart-offcanvas-wrapper .cart-button-wrap {\r\n    padding-right: 30px;\r\n  }\r\n\r\n  .extras-offcanvas-wrapper.active.offcanvas.offcanvas-end.show {\r\n    width: 640px;\r\n  }\r\n\r\n  .cart-booking-wrapper {\r\n    width: 540px;\r\n    bottom: 26px;\r\n  }\r\n\r\n  .cart-drawer-main-wrapper .booking-item-image {\r\n    width: 26px;\r\n    height: 26px;\r\n  }\r\n\r\n  .booking-cart-item-left {\r\n    gap: 8px;\r\n  }\r\n\r\n  .cart-total-wrap {\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .cart-total-wrap h3 {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .cart-total-wrap h4 {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .cart-drawer-main-wrap .booking-cart-item-repeat {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .cart-drawer-retail-wrap h4 {\r\n    font-size: 16px;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .cart-square-image img {\r\n    width: 80px;\r\n  }\r\n\r\n  .cart-drawer-main-wrapper .booking-item-detail h6 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .cart-drawer-main-wrapper .booking-item-detail p {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .cart-drawer-main-wrapper .booking-item-detail span {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .cart-drawer-main-wrapper .booking-cart-item-right {\r\n    gap: 10px;\r\n  }\r\n\r\n  .cart-drawer-main-wrapper .update-quantity-btn span {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .cart-drawer-main-wrapper .booking-item-price-wrap p {\r\n    font-size: 16px;\r\n    min-width: 70px;\r\n  }\r\n\r\n  .cart-drawer-retail-wrap {\r\n    margin-top: 30px;\r\n  }\r\n\r\n  .notification-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n    width: 600px;\r\n    padding: 30px 0px 30px 70px;\r\n  }\r\n\r\n  .notification-date-wrap {\r\n    padding-top: 30px;\r\n  }\r\n\r\n  .notification-drawer-header h3 {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .drawer-close-icon-wrap img {\r\n    width: 34px;\r\n  }\r\n\r\n  .notification-drawer-header {\r\n    padding-bottom: 10px;\r\n  }\r\n\r\n  .notification-title-wrap h4 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .notification-item-image {\r\n    width: 32px;\r\n  }\r\n\r\n  .notification-order-repeat {\r\n    margin-top: 34px;\r\n  }\r\n\r\n  .chat-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n    width: 560px;\r\n  }\r\n\r\n  .cleaner-partner.left {\r\n    font-size: 14px;\r\n    margin-left: 10px;\r\n  }\r\n\r\n  .replay-chat-box-wrap .msg.left-msg .msg-text {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .replay-chat-box-wrap .msg .msg-text {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .msg-bubble {\r\n    padding: 10px 16px;\r\n  }\r\n\r\n  .right-info-time p,\r\n  .left-info-time p {\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n    padding-top: 2px;\r\n    margin-left: 15px;\r\n    margin-right: 15px;\r\n  }\r\n\r\n  .chat-send-message-wrap input {\r\n    height: 68px;\r\n  }\r\n\r\n  .chat-send-button img {\r\n    width: 54px;\r\n    top: 8px;\r\n  }\r\n\r\n  .apply-coupan-btn {\r\n    position: absolute;\r\n    top: 6px;\r\n    right: 8px;\r\n  }\r\n\r\n  .coupan-more-offers-wrap {\r\n    margin-top: 30px;\r\n  }\r\n\r\n  .apply-coupan-btn button {\r\n    font-size: 13px;\r\n  }\r\n\r\n  .replay-chat-box-wrapper {\r\n    height: calc(100vh - 130px);\r\n  }\r\n\r\n  .noting-found-main-wrap img {\r\n    width: 100px;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .noting-found-main-wrap p {\r\n    font-size: 22px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1600px) {\r\n  .cart-drawer-main-wrap {\r\n    padding-right: 40px;\r\n  }\r\n}\r\n\r\n@media (min-width: 2000px) {\r\n  .history-centered-icon {\r\n    text-align: center;\r\n    margin-left: -20px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
